import gt, { useState as k, forwardRef as Ne, useEffect as L, useRef as Re, useCallback as W, createContext as fn, useContext as Ge, useMemo as hn, useLayoutEffect as mo } from "react";
import { SvgIcon as N, IconButton as J, Box as h, Divider as xt, Dialog as go, Slide as bt, Typography as R, useMediaQuery as be, createTheme as vt, ThemeProvider as Ve, CssBaseline as xo, GlobalStyles as bo, Link as G, useTheme as mn, Collapse as yt, Container as ie, Popover as wt, InputBase as vo, InputAdornment as yo } from "@mui/material";
import { Navigation as wo, Pagination as Co } from "swiper";
import { Swiper as ko, SwiperSlide as So } from "swiper/react";
import _e from "deepmerge";
import { nanoid as Ct } from "nanoid";
import { RemoveScroll as Eo } from "react-remove-scroll";
import "@mui/lab";
import { Element as _o } from "react-scroll";
import { debounce as Io } from "lodash-es";
import { InView as To, useInView as Ro } from "react-intersection-observer";
import { useIdleTimer as Ao } from "react-idle-timer";
import { keyframes as Po, css as Lo } from "@emotion/react";
async function Ri(e, t) {
  const o = await fetch(e, {
    ...t,
    headers: {
      "Content-Type": "application/json",
      ...t == null ? void 0 : t.headers
    }
  }), { response: i } = await o.json();
  return i;
}
function Ai(e) {
  const { response: t } = e;
  return typeof t == "object" && t !== null && "errors" in t;
}
function Oo(e) {
  return Array.isArray(e) ? [] : {};
}
function Mo(e, t, o = {}) {
  const i = e.slice();
  return t.forEach((a, s) => {
    var l, c;
    typeof i[s] === void 0 ? i[s] = (l = o.isMergeableObject) != null && l.call(o, a) ? _e(Oo(a), a, o) : a : (c = o.isMergeableObject) != null && c.call(o, a) ? i[s] = _e(e[s], a, o) : e.includes(a) || i.push(a);
  }), i;
}
function lt(e, t = {}) {
  return _e(e, t, { arrayMerge: Mo });
}
function Ae(e, t) {
  let o = e;
  for (const [i, a] of Object.entries(t)) {
    const s = RegExp(`{${i}}`, "g");
    let l;
    for (; (l = s.exec(o)) !== null; )
      o = o.replace(l[0], `${a}`);
  }
  return o;
}
const Do = {
  error: (...e) => console.error("[acm:error]", ...e),
  warn: (...e) => console.warn("[acm:warning]", ...e),
  info: (...e) => console.info("[acm:info]", ...e),
  debug: (...e) => console.debug("[acm:debug]", ...e)
};
function Pi(e, t) {
  return e.reduce((o, i) => t[i] ? [...o, t[i]] : o, []);
}
function B(...e) {
  return e.reduce(
    (t, o = []) => Array.isArray(t) ? [...t, ...Array.isArray(o) ? o : [o]] : t,
    []
  );
}
function F(e) {
  var t;
  try {
    const i = decodeURIComponent(document.cookie).split(";").map((a) => a.trimStart()).find((a) => a.startsWith(`${e}=`));
    return (t = i == null ? void 0 : i.split("=")[1]) != null ? t : null;
  } catch {
    return null;
  }
}
function re(e, t, o, i = !1, a, s) {
  const l = new Date();
  l.setTime(l.getTime() + o * 60 * 1e3), document.cookie = `${e}=${i ? btoa(String(t)) : t};expires=${l.toUTCString()};path=/;${a ? `domain=${a};` : ""}${s ? "Secure;" : ""}`;
}
function ht(e, t) {
  document.cookie = `${e}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;${t ? `domain=${t};` : ""}`;
}
function He(e) {
  e.forEach((t) => {
    typeof t == "string" ? ht(t) : ht(t.name, t.domain);
  });
}
function Ee(e, t) {
  var o, i;
  return (i = (o = t.config.find(({ key: a }) => a === e)) == null ? void 0 : o.value) != null ? i : null;
}
function ee(e) {
  try {
    typeof window !== void 0 && (window.dataLayer = window.dataLayer || []), window.dataLayer.push(e);
  } catch {
    console.warn("Error: GTM container not loaded");
  }
}
const Wo = ["en", "bm"], gn = "en", Li = {
  en: "eng",
  bm: "may"
}, tn = "acm_bcp_shown", nn = "acm_entry_modal_shown", xn = "acm_lang", fe = "acm_ulm_access_token", Fe = "acm_ulm_refresh_token", Q = "acm_ulm_uuid", Ue = "AstroUlmEPUID", pe = "acm_ulm_payload", on = "acm_ulm_handler_triggered", Bo = "login_url", Ie = "ulm_profile", mt = "acm_lang", jo = ["pink.cat", "astro.com.my"];
function zo(e) {
  const t = new RegExp(`(${jo.join("|")})`, "g"), o = e.match(t);
  return o && o[0];
}
function ve(e) {
  const t = zo(e);
  return t ? `.${t}` : void 0;
}
function bn(e) {
  return Wo.findIndex((t) => t === e) >= 0;
}
function vn(e, t) {
  e && bn(e) && (window.dispatchEvent(new CustomEvent(mt, { detail: e })), re(xn, e, 5e5, !1, ve(window.location.hostname)), t == null || t(e));
}
function ue(e) {
  window.dispatchEvent(new CustomEvent(Ie, { detail: e }));
}
function Ho(e) {
  if (e.urlParams.domain) {
    const { domain: t, pathname: o, params: i } = e.urlParams, a = Object.entries(i).reduce((c, [p, g]) => {
      var u;
      if (p === "state") {
        const m = (u = F(Q)) != null ? u : Ct(), x = encodeURIComponent(g).replace("DEVICE_ID_REPLACER", m).replace("LOCATION_REPLACER", "{location}");
        c.push(`state=${x}`);
      } else
        c.push(`${p}=${encodeURIComponent(g)}`);
      return c;
    }, []), s = a.length ? `?${a.join("&")}` : "", l = t + o + s;
    return window.dispatchEvent(new CustomEvent(Bo, { detail: l })), l;
  }
}
function Uo(e) {
  if (e) {
    const t = encodeURIComponent(window.location.href);
    window.location.href = Ae(e, { location: t });
  }
}
function $o() {
  const e = ve(window.location.hostname);
  He([
    { name: fe, domain: e },
    { name: Fe, domain: e },
    { name: pe, domain: e },
    { name: Q, domain: e },
    { name: Ue, domain: e }
  ]), ue();
}
async function Fo(e) {
  var u;
  const { client: t, expiry: o, sessionApi: i } = e, a = F(Q), s = ve(window.location.hostname), l = F(fe), c = F(Fe);
  let p;
  a ? p = a : (p = Ct(), re(Q, p, o.refreshSession || 3600, !1, s, !0));
  let g = null;
  if (l && i.getUser)
    try {
      const x = await (await fetch(i.getUser, {
        method: "POST",
        headers: {
          Authorization: l
        }
      })).json();
      re(pe, "acm", o.refreshSession, !1, s, !0);
      const { ulm: d, ulmProfileToken: w = "" } = x.response;
      g = { ...d, ulmProfileToken: w }, ue(g);
    } catch (m) {
      console.error(m), He([
        { name: fe, domain: s },
        { name: pe, domain: s },
        { name: Q, domain: s },
        { name: Ue, domain: s }
      ]), ue();
    }
  else if (c && i.refresh)
    try {
      const d = (await (await fetch(i.refresh, {
        method: "POST",
        headers: {
          Authorization: c,
          Client: t,
          "Device-Id": p,
          "Content-Type": "application/json",
          "Ulm-Redirect-Uri": document.location.href
        }
      })).json()).response;
      re(fe, (u = d.token) != null ? u : "", o.startSession, !1, s, !0), re(pe, "acm", o.refreshSession, !1, s, !0);
      const { ulm: w, ulmProfileToken: y = "" } = d;
      g = { ...w, ulmProfileToken: y }, ue(g);
    } catch (m) {
      console.error(m), He([
        { name: fe, domain: s },
        { name: Fe, domain: s },
        { name: pe, domain: s },
        { name: Q, domain: s },
        { name: Ue, domain: s }
      ]), ue();
    }
  else
    He([
      { name: pe, domain: s },
      { name: Q, domain: s },
      { name: Ue, domain: s }
    ]), ue();
  return g;
}
function No() {
  return !!(F(fe) || F(Fe));
}
var Ye = { exports: {} }, ke = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rn;
function Go() {
  if (rn)
    return ke;
  rn = 1;
  var e = gt, t = Symbol.for("react.element"), o = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, p, g) {
    var u, m = {}, x = null, d = null;
    g !== void 0 && (x = "" + g), p.key !== void 0 && (x = "" + p.key), p.ref !== void 0 && (d = p.ref);
    for (u in p)
      i.call(p, u) && !s.hasOwnProperty(u) && (m[u] = p[u]);
    if (c && c.defaultProps)
      for (u in p = c.defaultProps, p)
        m[u] === void 0 && (m[u] = p[u]);
    return { $$typeof: t, type: c, key: x, ref: d, props: m, _owner: a.current };
  }
  return ke.Fragment = o, ke.jsx = l, ke.jsxs = l, ke;
}
var Se = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var an;
function Vo() {
  return an || (an = 1, process.env.NODE_ENV !== "production" && function() {
    var e = gt, t = Symbol.for("react.element"), o = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), w = Symbol.iterator, y = "@@iterator";
    function C(r) {
      if (r === null || typeof r != "object")
        return null;
      var f = w && r[w] || r[y];
      return typeof f == "function" ? f : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(r) {
      {
        for (var f = arguments.length, v = new Array(f > 1 ? f - 1 : 0), S = 1; S < f; S++)
          v[S - 1] = arguments[S];
        $("error", r, v);
      }
    }
    function $(r, f, v) {
      {
        var S = E.ReactDebugCurrentFrame, A = S.getStackAddendum();
        A !== "" && (f += "%s", v = v.concat([A]));
        var P = v.map(function(T) {
          return String(T);
        });
        P.unshift("Warning: " + f), Function.prototype.apply.call(console[r], console, P);
      }
    }
    var se = !1, V = !1, le = !1, zn = !1, Hn = !1, Pt;
    Pt = Symbol.for("react.module.reference");
    function Un(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === s || Hn || r === a || r === g || r === u || zn || r === d || se || V || le || typeof r == "object" && r !== null && (r.$$typeof === x || r.$$typeof === m || r.$$typeof === l || r.$$typeof === c || r.$$typeof === p || r.$$typeof === Pt || r.getModuleId !== void 0));
    }
    function $n(r, f, v) {
      var S = r.displayName;
      if (S)
        return S;
      var A = f.displayName || f.name || "";
      return A !== "" ? v + "(" + A + ")" : v;
    }
    function Lt(r) {
      return r.displayName || "Context";
    }
    function Y(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case o:
          return "Portal";
        case s:
          return "Profiler";
        case a:
          return "StrictMode";
        case g:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            var f = r;
            return Lt(f) + ".Consumer";
          case l:
            var v = r;
            return Lt(v._context) + ".Provider";
          case p:
            return $n(r, r.render, "ForwardRef");
          case m:
            var S = r.displayName || null;
            return S !== null ? S : Y(r.type) || "Memo";
          case x: {
            var A = r, P = A._payload, T = A._init;
            try {
              return Y(T(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ne = Object.assign, we = 0, Ot, Mt, Dt, Wt, Bt, jt, zt;
    function Ht() {
    }
    Ht.__reactDisabledLog = !0;
    function Fn() {
      {
        if (we === 0) {
          Ot = console.log, Mt = console.info, Dt = console.warn, Wt = console.error, Bt = console.group, jt = console.groupCollapsed, zt = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: Ht,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        we++;
      }
    }
    function Nn() {
      {
        if (we--, we === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ne({}, r, {
              value: Ot
            }),
            info: ne({}, r, {
              value: Mt
            }),
            warn: ne({}, r, {
              value: Dt
            }),
            error: ne({}, r, {
              value: Wt
            }),
            group: ne({}, r, {
              value: Bt
            }),
            groupCollapsed: ne({}, r, {
              value: jt
            }),
            groupEnd: ne({}, r, {
              value: zt
            })
          });
        }
        we < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var et = E.ReactCurrentDispatcher, tt;
    function Oe(r, f, v) {
      {
        if (tt === void 0)
          try {
            throw Error();
          } catch (A) {
            var S = A.stack.trim().match(/\n( *(at )?)/);
            tt = S && S[1] || "";
          }
        return `
` + tt + r;
      }
    }
    var nt = !1, Me;
    {
      var Gn = typeof WeakMap == "function" ? WeakMap : Map;
      Me = new Gn();
    }
    function Ut(r, f) {
      if (!r || nt)
        return "";
      {
        var v = Me.get(r);
        if (v !== void 0)
          return v;
      }
      var S;
      nt = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = et.current, et.current = null, Fn();
      try {
        if (f) {
          var T = function() {
            throw Error();
          };
          if (Object.defineProperty(T.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(T, []);
            } catch (q) {
              S = q;
            }
            Reflect.construct(r, [], T);
          } else {
            try {
              T.call();
            } catch (q) {
              S = q;
            }
            r.call(T.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (q) {
            S = q;
          }
          r();
        }
      } catch (q) {
        if (q && S && typeof q.stack == "string") {
          for (var _ = q.stack.split(`
`), j = S.stack.split(`
`), O = _.length - 1, M = j.length - 1; O >= 1 && M >= 0 && _[O] !== j[M]; )
            M--;
          for (; O >= 1 && M >= 0; O--, M--)
            if (_[O] !== j[M]) {
              if (O !== 1 || M !== 1)
                do
                  if (O--, M--, M < 0 || _[O] !== j[M]) {
                    var H = `
` + _[O].replace(" at new ", " at ");
                    return r.displayName && H.includes("<anonymous>") && (H = H.replace("<anonymous>", r.displayName)), typeof r == "function" && Me.set(r, H), H;
                  }
                while (O >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        nt = !1, et.current = P, Nn(), Error.prepareStackTrace = A;
      }
      var de = r ? r.displayName || r.name : "", en = de ? Oe(de) : "";
      return typeof r == "function" && Me.set(r, en), en;
    }
    function Vn(r, f, v) {
      return Ut(r, !1);
    }
    function Yn(r) {
      var f = r.prototype;
      return !!(f && f.isReactComponent);
    }
    function De(r, f, v) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ut(r, Yn(r));
      if (typeof r == "string")
        return Oe(r);
      switch (r) {
        case g:
          return Oe("Suspense");
        case u:
          return Oe("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case p:
            return Vn(r.render);
          case m:
            return De(r.type, f, v);
          case x: {
            var S = r, A = S._payload, P = S._init;
            try {
              return De(P(A), f, v);
            } catch {
            }
          }
        }
      return "";
    }
    var We = Object.prototype.hasOwnProperty, $t = {}, Ft = E.ReactDebugCurrentFrame;
    function Be(r) {
      if (r) {
        var f = r._owner, v = De(r.type, r._source, f ? f.type : null);
        Ft.setExtraStackFrame(v);
      } else
        Ft.setExtraStackFrame(null);
    }
    function qn(r, f, v, S, A) {
      {
        var P = Function.call.bind(We);
        for (var T in r)
          if (P(r, T)) {
            var _ = void 0;
            try {
              if (typeof r[T] != "function") {
                var j = Error((S || "React class") + ": " + v + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw j.name = "Invariant Violation", j;
              }
              _ = r[T](f, T, S, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (O) {
              _ = O;
            }
            _ && !(_ instanceof Error) && (Be(A), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", v, T, typeof _), Be(null)), _ instanceof Error && !(_.message in $t) && ($t[_.message] = !0, Be(A), I("Failed %s type: %s", v, _.message), Be(null));
          }
      }
    }
    var Kn = Array.isArray;
    function ot(r) {
      return Kn(r);
    }
    function Jn(r) {
      {
        var f = typeof Symbol == "function" && Symbol.toStringTag, v = f && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return v;
      }
    }
    function Zn(r) {
      try {
        return Nt(r), !1;
      } catch {
        return !0;
      }
    }
    function Nt(r) {
      return "" + r;
    }
    function Gt(r) {
      if (Zn(r))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Jn(r)), Nt(r);
    }
    var Ce = E.ReactCurrentOwner, Xn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Vt, Yt, rt;
    rt = {};
    function Qn(r) {
      if (We.call(r, "ref")) {
        var f = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (f && f.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function eo(r) {
      if (We.call(r, "key")) {
        var f = Object.getOwnPropertyDescriptor(r, "key").get;
        if (f && f.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function to(r, f) {
      if (typeof r.ref == "string" && Ce.current && f && Ce.current.stateNode !== f) {
        var v = Y(Ce.current.type);
        rt[v] || (I('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(Ce.current.type), r.ref), rt[v] = !0);
      }
    }
    function no(r, f) {
      {
        var v = function() {
          Vt || (Vt = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
        };
        v.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: v,
          configurable: !0
        });
      }
    }
    function oo(r, f) {
      {
        var v = function() {
          Yt || (Yt = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", f));
        };
        v.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: v,
          configurable: !0
        });
      }
    }
    var ro = function(r, f, v, S, A, P, T) {
      var _ = {
        $$typeof: t,
        type: r,
        key: f,
        ref: v,
        props: T,
        _owner: P
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function io(r, f, v, S, A) {
      {
        var P, T = {}, _ = null, j = null;
        v !== void 0 && (Gt(v), _ = "" + v), eo(f) && (Gt(f.key), _ = "" + f.key), Qn(f) && (j = f.ref, to(f, A));
        for (P in f)
          We.call(f, P) && !Xn.hasOwnProperty(P) && (T[P] = f[P]);
        if (r && r.defaultProps) {
          var O = r.defaultProps;
          for (P in O)
            T[P] === void 0 && (T[P] = O[P]);
        }
        if (_ || j) {
          var M = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          _ && no(T, M), j && oo(T, M);
        }
        return ro(r, _, j, A, S, Ce.current, T);
      }
    }
    var it = E.ReactCurrentOwner, qt = E.ReactDebugCurrentFrame;
    function ce(r) {
      if (r) {
        var f = r._owner, v = De(r.type, r._source, f ? f.type : null);
        qt.setExtraStackFrame(v);
      } else
        qt.setExtraStackFrame(null);
    }
    var at;
    at = !1;
    function st(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function Kt() {
      {
        if (it.current) {
          var r = Y(it.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function ao(r) {
      {
        if (r !== void 0) {
          var f = r.fileName.replace(/^.*[\\\/]/, ""), v = r.lineNumber;
          return `

Check your code at ` + f + ":" + v + ".";
        }
        return "";
      }
    }
    var Jt = {};
    function so(r) {
      {
        var f = Kt();
        if (!f) {
          var v = typeof r == "string" ? r : r.displayName || r.name;
          v && (f = `

Check the top-level render call using <` + v + ">.");
        }
        return f;
      }
    }
    function Zt(r, f) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var v = so(f);
        if (Jt[v])
          return;
        Jt[v] = !0;
        var S = "";
        r && r._owner && r._owner !== it.current && (S = " It was passed a child from " + Y(r._owner.type) + "."), ce(r), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', v, S), ce(null);
      }
    }
    function Xt(r, f) {
      {
        if (typeof r != "object")
          return;
        if (ot(r))
          for (var v = 0; v < r.length; v++) {
            var S = r[v];
            st(S) && Zt(S, f);
          }
        else if (st(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var A = C(r);
          if (typeof A == "function" && A !== r.entries)
            for (var P = A.call(r), T; !(T = P.next()).done; )
              st(T.value) && Zt(T.value, f);
        }
      }
    }
    function lo(r) {
      {
        var f = r.type;
        if (f == null || typeof f == "string")
          return;
        var v;
        if (typeof f == "function")
          v = f.propTypes;
        else if (typeof f == "object" && (f.$$typeof === p || f.$$typeof === m))
          v = f.propTypes;
        else
          return;
        if (v) {
          var S = Y(f);
          qn(v, r.props, "prop", S, r);
        } else if (f.PropTypes !== void 0 && !at) {
          at = !0;
          var A = Y(f);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof f.getDefaultProps == "function" && !f.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function co(r) {
      {
        for (var f = Object.keys(r.props), v = 0; v < f.length; v++) {
          var S = f[v];
          if (S !== "children" && S !== "key") {
            ce(r), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", S), ce(null);
            break;
          }
        }
        r.ref !== null && (ce(r), I("Invalid attribute `ref` supplied to `React.Fragment`."), ce(null));
      }
    }
    function Qt(r, f, v, S, A, P) {
      {
        var T = Un(r);
        if (!T) {
          var _ = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var j = ao(A);
          j ? _ += j : _ += Kt();
          var O;
          r === null ? O = "null" : ot(r) ? O = "array" : r !== void 0 && r.$$typeof === t ? (O = "<" + (Y(r.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : O = typeof r, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", O, _);
        }
        var M = io(r, f, v, A, P);
        if (M == null)
          return M;
        if (T) {
          var H = f.children;
          if (H !== void 0)
            if (S)
              if (ot(H)) {
                for (var de = 0; de < H.length; de++)
                  Xt(H[de], r);
                Object.freeze && Object.freeze(H);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xt(H, r);
        }
        return r === i ? co(M) : lo(M), M;
      }
    }
    function po(r, f, v) {
      return Qt(r, f, v, !0);
    }
    function uo(r, f, v) {
      return Qt(r, f, v, !1);
    }
    var fo = uo, ho = po;
    Se.Fragment = i, Se.jsx = fo, Se.jsxs = ho;
  }()), Se;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Go() : e.exports = Vo();
})(Ye);
const z = Ye.exports.Fragment, n = Ye.exports.jsx, b = Ye.exports.jsxs, Yo = (e) => /* @__PURE__ */ b(N, {
  viewBox: "0 0 16 24",
  ...e,
  children: [/* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M3.49 22a1.477 1.477 0 01-1.053-.441 1.516 1.516 0 010-2.129L9.789 12 2.437 4.57a1.516 1.516 0 010-2.129 1.478 1.478 0 012.106 0L13.998 12l-9.455 9.559A1.477 1.477 0 013.49 22z"
  }), /* @__PURE__ */ n("path", {
    fill: "none",
    d: "M0 0h16v24H0z"
  })]
}), sn = ({
  children: e,
  direction: t,
  disabled: o,
  sideOffset: i,
  size: a
}) => /* @__PURE__ */ n(J, {
  className: t,
  sx: [{
    position: "absolute",
    top: `calc(50% - ${a / 2}px)`,
    zIndex: 20,
    fontSize: "inherit",
    color: "common.black",
    "& > svg": {
      fontSize: "inherit"
    }
  }, t === "prev" && {
    left: i,
    transform: "rotate(180deg)"
  }, t === "next" && {
    right: i
  }, !!o && {
    color: "grey.400"
  }],
  children: e
}), qo = ({
  edge: e,
  icon: t = Yo,
  loop: o,
  sideOffset: i = 16,
  size: a = 24
}) => /* @__PURE__ */ b(h, {
  className: "navigation-container",
  sx: {
    fontSize: `${a}px`
  },
  children: [/* @__PURE__ */ n(sn, {
    direction: "prev",
    disabled: !o && e === "beginning",
    sideOffset: i,
    size: a,
    children: /* @__PURE__ */ n(t, {})
  }), /* @__PURE__ */ n(sn, {
    direction: "next",
    disabled: !o && e === "end",
    sideOffset: i,
    size: a,
    children: /* @__PURE__ */ n(t, {})
  })]
}), Ko = ({
  bottomOffset: e = 16
}) => /* @__PURE__ */ n(h, {
  className: "pagination-container",
  sx: {
    position: "absolute",
    bottom: e,
    zIndex: 20,
    display: "flex",
    width: 1,
    justifyContent: "center",
    "& .swiper-pagination-bullet": {
      minWidth: {
        xs: 6,
        md: 8
      },
      width: {
        xs: 6,
        md: 8
      },
      height: {
        xs: 6,
        md: 8
      },
      mx: {
        xs: "3px",
        md: "4px"
      },
      bgcolor: "grey.300",
      borderRadius: 4,
      opacity: 1,
      cursor: "pointer",
      transition: ({
        transitions: t
      }) => t.create("min-width", {
        duration: t.duration.shortest
      }),
      "&-active": {
        minWidth: {
          xs: 24,
          md: 32
        },
        bgcolor: "primary.main"
      }
    }
  }
}), Jo = ({
  arrows: e,
  bullets: t,
  children: o,
  className: i,
  componentSx: a = {},
  id: s,
  initialSlide: l = 0,
  loop: c,
  noSwiping: p,
  noSwipingClass: g = "swiper-no-swiping",
  onSlideChange: u,
  ...m
}) => {
  const x = typeof e == "object" ? e : {}, d = typeof t == "object" ? t : {}, [w, y] = k(l === 0 ? "beginning" : !1), C = (E) => {
    y(E.isBeginning ? "beginning" : E.isEnd ? "end" : !1), u == null || u(E);
  };
  return /* @__PURE__ */ b(h, {
    id: s,
    sx: B({
      position: "relative",
      "& .swiper": a.root,
      "& .swiper-slide": a.slide,
      "& .pagination-container": a.bullets,
      "& .swiper-pagination-bullet": a.bullet,
      "& .swiper-pagination-bullet-active": a.activeBullet,
      "& .navigation-container": a.navigation,
      "& .navigation-container > .next, .navigation-container > .prev": a.arrow
    }, a.container),
    children: [/* @__PURE__ */ n(ko, {
      modules: [wo, Co],
      className: `${i} ${p ? g : ""}`,
      initialSlide: l,
      noSwiping: p,
      noSwipingClass: g,
      loop: c,
      navigation: e ? {
        nextEl: `#${s} > .navigation-container > .next`,
        prevEl: `#${s} > .navigation-container > .prev`
      } : !1,
      pagination: t ? {
        el: `#${s} > .pagination-container`,
        clickable: !0
      } : !1,
      onSlideChange: C,
      ...m,
      children: o
    }), e && /* @__PURE__ */ n(qo, {
      edge: w,
      loop: c,
      ...x
    }), t && /* @__PURE__ */ n(Ko, {
      ...d
    })]
  });
}, Zo = So, Oi = ({
  transitionBp: e = "md",
  sx: t,
  ...o
}) => /* @__PURE__ */ n(xt, {
  ...o,
  sx: B([{
    height: "1rem",
    mx: 4,
    border: 0,
    borderTop: 1,
    borderTopColor: "grey.400",
    bgcolor: "grey.200"
  }, e !== !1 && (({
    breakpoints: i
  }) => ({
    [i.up(e)]: {
      height: 0,
      mt: 8,
      mb: 0,
      borderTop: 0
    }
  }))], t)
}), ye = (e) => /* @__PURE__ */ n(N, {
  viewBox: "0 0 20 20",
  fontSize: "small",
  htmlColor: "inherit",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2",
  ...e,
  children: /* @__PURE__ */ n("path", {
    d: "M16 4.5l-12 12m0-12l12 12"
  })
}), Mi = () => /* @__PURE__ */ b(N, {
  children: [/* @__PURE__ */ n("path", {
    d: "M20.503 3.488a11.961 11.961 0 0 0-20.4 8.4 11.83 11.83 0 0 0 1.595 5.946L0 24l6.335-1.654a11.984 11.984 0 0 0 5.71 1.448h.005A11.939 11.939 0 0 0 24 11.9a11.794 11.794 0 0 0-3.5-8.414zm-8.453 18.3a9.954 9.954 0 0 1-5.055-1.378l-.363-.214-3.759.981 1-3.647-.236-.374a9.881 9.881 0 0 1 8.417-15.147 9.889 9.889 0 1 1 0 19.777z",
    fill: "#e0e0e0"
  }), /* @__PURE__ */ n("path", {
    d: "m.549 23.316 1.618-5.881a11.414 11.414 0 1 1 9.882 5.684h-.005a11.441 11.441 0 0 1-5.449-1.381L.55 23.316z",
    fill: "#20b038"
  }), /* @__PURE__ */ n("path", {
    d: "M9.097 6.843c-.221-.489-.454-.5-.664-.508-.172-.007-.369-.007-.566-.007a1.086 1.086 0 0 0-.787.368 3.287 3.287 0 0 0-1.033 2.45 5.7 5.7 0 0 0 1.205 3.039 12.1 12.1 0 0 0 5.042 4.435c2.493.979 3 .784 3.542.735a2.981 2.981 0 0 0 1.992-1.4 2.446 2.446 0 0 0 .172-1.4c-.074-.122-.271-.2-.566-.343s-1.746-.858-2.017-.956-.467-.147-.664.147-.762.956-.934 1.152-.344.221-.639.074a8.083 8.083 0 0 1-2.374-1.458 8.866 8.866 0 0 1-1.642-2.035c-.172-.294-.018-.453.13-.6.132-.132.3-.343.443-.515a2.018 2.018 0 0 0 .295-.49.538.538 0 0 0-.025-.515c-.074-.147-.647-1.6-.91-2.181z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /* @__PURE__ */ n("path", {
    d: "M20.406 3.45A11.79 11.79 0 0 0 1.814 17.635L.138 23.727 6.4 22.092a11.846 11.846 0 0 0 5.645 1.431h.005a11.8 11.8 0 0 0 11.813-11.754 11.659 11.659 0 0 0-3.457-8.317zM12.05 21.537a9.839 9.839 0 0 1-5-1.362l-.359-.212-3.716.97.992-3.606-.234-.37a9.827 9.827 0 1 1 8.317 4.579z",
    fill: "#f0f0f0"
  })]
}), ge = Ne(({
  sx: e,
  ...t
}, o) => /* @__PURE__ */ n(h, {
  ref: o,
  ...t,
  sx: B({
    display: "flex"
  }, e)
})), kt = Ne(({
  sx: e,
  ...t
}, o) => /* @__PURE__ */ n(h, {
  ref: o,
  ...t,
  sx: B({
    display: "grid",
    gap: 2
  }, e)
})), Pe = ({
  children: e,
  onPagehide: t,
  ScrollerProps: o,
  ...i
}) => (L(() => {
  if (t)
    return window.addEventListener("pagehide", t), () => window.removeEventListener("pagehide", t);
}, [t]), /* @__PURE__ */ n(go, {
  ...i,
  children: /* @__PURE__ */ n(Eo, {
    removeScrollBar: !1,
    forwardProps: !0,
    children: /* @__PURE__ */ n(h, {
      sx: {
        overflow: "auto",
        WebkitOverflowScrolling: "touch"
      },
      ...o,
      children: e
    })
  })
})), Xo = ({
  PaperProps: e = {},
  ...t
}) => /* @__PURE__ */ n(Pe, {
  ...t,
  PaperProps: {
    ...e,
    sx: B(({
      breakpoints: o
    }) => ({
      m: "auto",
      borderRadius: 2,
      width: 328,
      maxWidth: "calc(100% - 2rem)",
      maxHeight: "calc(100% - 2rem)",
      [o.up(360)]: {
        maxWidth: 328
      }
    }), e.sx)
  }
}), Qo = Ne((e, t) => /* @__PURE__ */ n(bt, {
  direction: "up",
  ref: t,
  ...e
})), Di = ({
  large: e,
  PaperProps: t = {},
  ...o
}) => /* @__PURE__ */ n(Pe, {
  ...o,
  PaperProps: {
    ...t,
    sx: B({
      width: 1,
      maxWidth: e ? 768 : 640,
      height: "100vh",
      maxHeight: 1,
      m: 0,
      borderRadius: 0,
      WebkitOverflowScrolling: "touch"
    }, t.sx)
  },
  TransitionComponent: Qo
}), Wi = ({
  heading: e,
  subHeading: t,
  headingProps: o,
  ...i
}) => /* @__PURE__ */ b(h, {
  ...i,
  children: [/* @__PURE__ */ n(R, {
    variant: "h2",
    ...o,
    sx: {
      mb: 2
    },
    children: e
  }), t && /* @__PURE__ */ n(R, {
    dangerouslySetInnerHTML: {
      __html: t
    }
  })]
});
function ln(e) {
  const t = Re(null);
  return t.current === null && (t.current = typeof e == "function" ? e() : e), t.current;
}
function yn(e, t = "up") {
  return be(
    (o) => t === "up" ? o.breakpoints.up(e) : o.breakpoints.down(e)
  );
}
function Bi() {
  return be("(prefers-reduced-motion: reduce)");
}
const St = {
  values: {
    xs: 0,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1280
  }
}, wn = {
  MuiContainer: {
    defaultProps: {
      maxWidth: "xl"
    },
    styleOverrides: {
      root: ({ theme: e }) => ({
        paddingLeft: 16,
        paddingRight: 16,
        [e.breakpoints.between("xs", "xl")]: {
          paddingLeft: 16,
          paddingRight: 16
        },
        [e.breakpoints.up("xl")]: {
          paddingLeft: 72,
          paddingRight: 72
        }
      }),
      disableGutters: ({ theme: e }) => ({
        paddingLeft: 0,
        paddingRight: 0,
        [e.breakpoints.up("xs")]: {
          paddingLeft: 0,
          paddingRight: 0
        }
      })
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        margin: "1rem 0"
      },
      vertical: {
        margin: 0
      },
      light: ({ theme: e }) => ({
        backgroundColor: e.palette.background.default,
        opacity: 0.4
      })
    }
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
      variant: "outlined"
    },
    styleOverrides: {
      outlined: ({ theme: e }) => ({
        border: `1px solid ${e.palette.grey[300]}`
      })
    }
  },
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.75)"
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        border: "none"
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        "& a": {
          color: e.palette.primary.main,
          textDecoration: "none",
          cursor: "pointer"
        },
        "& s": {
          color: e.palette.grey[600]
        }
      })
    }
  },
  MuiCircularProgress: {
    defaultProps: {
      size: 64,
      thickness: 5.2
    },
    styleOverrides: {
      circle: {
        strokeLinecap: "round"
      }
    }
  },
  MuiSkeleton: {
    styleOverrides: {
      root: ({ ownerState: e, theme: t }) => ({
        bgcolor: t.palette.grey[200],
        borderRadius: 8,
        ...e.variant === "text" && {
          transform: "scale(1, 0.8)"
        }
      })
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiButton: {
    defaultProps: {
      disableElevation: !0,
      variant: "contained"
    },
    styleOverrides: {
      sizeSmall: {
        height: "2rem",
        paddingLeft: "1rem",
        paddingRight: "1rem"
      },
      sizeMedium: ({ theme: e }) => ({
        height: "3rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        [e.breakpoints.up("md")]: {
          paddingLeft: "1.5rem",
          paddingRight: "1.5rem"
        }
      }),
      textSizeMedium: ({ theme: e }) => ({
        height: "auto",
        padding: 0,
        [e.breakpoints.up("md")]: {
          padding: 0
        }
      }),
      contained: ({ theme: e }) => ({
        color: e.palette.primary.contrastText,
        backgroundColor: "transparent",
        backgroundImage: `linear-gradient(to right, ${e.palette.primary.light}, ${e.palette.primary.dark})`,
        transitionProperty: "none",
        "&:hover": {
          backgroundColor: "inherit",
          backgroundImage: "linear-gradient(to right, #cf0071, #d0283a)",
          "&:disabled": {
            backgroundColor: e.palette.grey[50]
          }
        },
        "&:focus-visible": {
          borderColor: e.palette.secondary.main
        },
        "&:disabled": {
          color: e.palette.grey[400],
          backgroundImage: "none",
          backgroundColor: e.palette.grey[50],
          "&.MuiButton-disableElevation": {
            boxShadow: `inset 0 0 0 1px ${e.palette.grey[300]}`
          }
        }
      }),
      outlined: ({ theme: e }) => ({
        color: e.palette.text.primary,
        border: `solid 1px ${e.palette.grey[600]}`,
        backgroundColor: e.palette.background.default,
        "&:hover": {
          borderColor: e.palette.grey[600],
          backgroundColor: e.palette.grey[100]
        },
        "&:focus-visible": {
          borderColor: e.palette.secondary.main
        },
        "&:disabled": {
          color: e.palette.grey[400],
          borderColor: e.palette.grey[300]
        }
      }),
      text: ({ theme: e }) => ({
        minWidth: 0,
        padding: 0,
        fontWeight: "normal",
        lineHeight: "1.375rem",
        [e.breakpoints.up("md")]: {
          padding: 0
        },
        "&:hover": {
          backgroundColor: "inherit"
        },
        "&:disabled": {
          color: e.palette.grey[400]
        }
      }),
      textPrimary: {
        "&:hover": {
          backgroundColor: "inherit"
        }
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        padding: 0,
        "&:hover": {
          backgroundColor: "transparent"
        }
      },
      colorSecondary: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        padding: "1rem 0.5rem",
        minWidth: "6rem",
        maxWidth: "6rem"
      },
      textColorInherit: ({ theme: e }) => ({
        opacity: 0.4,
        transition: e.transitions.create("opacity", {
          duration: e.transitions.duration.shortest
        }),
        "&.Mui-selected": {
          opacity: 1,
          fontWeight: "bold"
        }
      }),
      labelIcon: {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "1rem",
        fontWeight: "normal",
        lineHeight: "19px"
      }
    }
  },
  MuiTabPanel: {
    styleOverrides: {
      root: {
        padding: 0
      }
    }
  },
  MuiTabs: {
    defaultProps: {
      indicatorColor: "primary",
      textColor: "inherit"
    },
    styleOverrides: {
      root: ({ theme: e }) => ({
        position: "relative",
        "::after": {
          content: "''",
          position: "absolute",
          zIndex: -1,
          bottom: 0,
          width: "100%",
          height: 2,
          backgroundColor: e.palette.grey[400],
          borderRadius: 2
        }
      }),
      flexContainer: {
        alignItems: "start"
      },
      indicator: {
        zIndex: 1,
        borderRadius: 2
      }
    }
  }
}, Et = {
  mode: "light",
  primary: {
    main: "#e6007d",
    light: "#e6007d",
    dark: "#e72f3b",
    contrastText: "#fff"
  },
  secondary: {
    main: "#1d7fe3",
    contrastText: "#fff"
  },
  error: {
    light: "#fad9d9",
    main: "#ff0000",
    contrastText: "#d2181e"
  },
  warning: {
    main: "#fff2b2",
    dark: "#ffd501",
    contrastText: "#f84d1d"
  },
  success: {
    main: "#d3f9b2",
    contrastText: "#167e14"
  },
  common: {
    black: "#010414",
    white: "#fff"
  },
  grey: {
    50: "#f8f8f8",
    100: "#f0f0f0",
    200: "#e9e9ee",
    300: "#d8d8d8",
    400: "#b2b3b8",
    500: "#9e9e9e",
    600: "#86878b",
    700: "#616161",
    800: "#4d4f5a",
    900: "#333"
  },
  text: {
    primary: "#010414",
    disabled: "#b2b3b8"
  },
  divider: "#d8d8d8",
  background: {
    default: "#fff",
    paper: "#fff"
  }
}, Cn = [
  "none",
  "0 4px 8px 0 rgba(0, 0, 0, 0.1)",
  "0 5px 8px 0 rgba(0, 0, 0, 0.1)",
  "0 6px 8px 0 rgba(0, 0, 0, 0.1)",
  "0 7px 8px 0 rgba(0, 0, 0, 0.1)",
  "0 8px 9px 0 rgba(0, 0, 0, 0.1)",
  "0 9px 9px 0 rgba(0, 0, 0, 0.1)",
  "0 10px 10px 0 rgba(0, 0, 0, 0.1)",
  "0 11px 10px 0 rgba(0, 0, 0, 0.1)",
  "0 12px 12px 0 rgba(0, 0, 0, 0.1)",
  "0 13px 12px 0 rgba(0, 0, 0, 0.1)",
  "0 14px 14px 0 rgba(0, 0, 0, 0.1)",
  "0 15px 14px 0 rgba(0, 0, 0, 0.1)",
  "0 16px 16px 0 rgba(0, 0, 0, 0.1)",
  "0 17px 16px 0 rgba(0, 0, 0, 0.1)",
  "0 18px 18px 0 rgba(0, 0, 0, 0.1)",
  "0 19px 18px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)",
  "0 20px 20px 0 rgba(0, 0, 0, 0.1)"
], _t = {
  borderRadius: 8
}, It = 8, Tt = {
  htmlFontSize: 16,
  fontFamily: [
    "'FS Albert Pro'",
    "-apple-system",
    "BlinkMacSystemFont",
    "'Segoe UI'",
    "Roboto",
    "'Helvetica Neue'",
    "Arial",
    "Microsoft YaHei",
    "\u5FAE\u8F6F\u96C5\u9ED1",
    "STXihei",
    "\u534E\u6587\u7EC6\u9ED1",
    "sans-serif",
    "'Apple Color Emoji'",
    "'Segoe UI Emoji'",
    "'Segoe UI Symbol'"
  ].join(","),
  h1: {
    fontSize: "1.75rem",
    fontWeight: 800,
    lineHeight: "2.125rem"
  },
  h2: {
    fontSize: "1.5rem",
    fontWeight: 800,
    lineHeight: "1.875rem"
  },
  h3: {
    fontSize: "1.25rem",
    fontWeight: 800,
    lineHeight: "1.625rem"
  },
  h4: {
    fontSize: "1rem",
    fontWeight: 800,
    lineHeight: "1.375rem"
  },
  h5: {
    fontSize: "0.875rem",
    fontWeight: 800,
    lineHeight: "1.25rem"
  },
  h6: {
    fontSize: "0.75rem",
    fontWeight: 800,
    lineHeight: "1.125rem"
  },
  body1: {
    fontSize: "1rem",
    lineHeight: "1.375rem"
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: "1.25rem"
  },
  caption: {
    fontSize: "0.75rem",
    lineHeight: "1.125rem"
  },
  button: {
    fontSize: "1rem",
    lineHeight: 1,
    fontWeight: "bold",
    textTransform: "none"
  }
};
function er(e = "main") {
  return {
    "html, body, p, ul": {
      margin: 0,
      padding: 0
    },
    a: {
      color: "inherit",
      textDecoration: "none"
    },
    ul: {
      listStyle: "none"
    },
    b: {
      fontWeight: "bold"
    },
    strong: {
      fontWeight: "800"
    },
    [`#${e}`]: {
      minHeight: "100vh"
    }
  };
}
function tr() {
  return vt({
    breakpoints: St,
    components: wn,
    palette: Et,
    shadows: Cn,
    shape: _t,
    spacing: It,
    typography: Tt
  });
}
const nr = ({
  children: e,
  containerId: t = "main",
  globalStyles: o,
  theme: i
}) => {
  const a = ln(er(t)), s = ln(tr());
  return /* @__PURE__ */ b(Ve, {
    theme: i != null ? i : s,
    children: [/* @__PURE__ */ n(xo, {}), /* @__PURE__ */ n(bo, {
      styles: o != null ? o : a
    }), e]
  });
}, ji = {
  breakpoints: St,
  components: wn,
  palette: Et,
  shadows: Cn,
  shape: _t,
  spacing: It,
  typography: Tt
};
function or(e) {
  return Boolean(e && e.ulmProfileToken);
}
function rr(e) {
  return Boolean(e.astro_entitlements && e.user_accountNumber && e.user_contactId);
}
function ct({
  ulmConfig: e,
  promptLogin: t = !1,
  ulmUuid: o,
  redirectUrl: i
}) {
  const { url: a, domain: s, rp: l, handler: c, scope: p } = e;
  return Ae(a, {
    domain: s,
    loginPrompt: t ? "prompt=login" : "",
    clientId: encodeURIComponent(l),
    scope: encodeURIComponent(p.join(" ")),
    redirectUri: encodeURIComponent(c),
    redirectUrl: encodeURIComponent(i),
    ulmUuid: String(o)
  });
}
function ir(e) {
  const [t, o] = k(!0), [i, a] = k(!1), [s, l] = k(!1), [c, p] = k("");
  return L(() => {
    var w;
    const g = window.location.href, u = ve(window.location.hostname), m = (w = F(Q)) != null ? w : Ct(), x = F(on);
    ht(on, u), p(ct({ ulmConfig: e, promptLogin: Boolean(x), ulmUuid: m, redirectUrl: g }));
    const d = (y) => {
      if (y.detail && or(y.detail)) {
        l(!1);
        const C = rr(y.detail);
        C || p(ct({ ulmConfig: e, promptLogin: !0, ulmUuid: m, redirectUrl: g })), a(C), o(!1);
      } else
        x ? (l(!0), a(!1), o(!1)) : window.location.href = ct({
          ulmConfig: e,
          ulmUuid: m,
          redirectUrl: g
        });
    };
    return window.addEventListener(Ie, d), () => {
      window.removeEventListener(Ie, d);
    };
  }, [e]), { loading: t, is2fa: i, error: s, loginUrl: c };
}
const zi = ({
  config: {
    ulmConfig: e,
    cancelUrl: t,
    loginErrorPathname: o,
    not2faErrorPathname: i,
    onLoggedIn: a,
    loadingText: s,
    loginErrorMessage: l,
    not2faErrorMessage: c
  },
  LoadingComponent: p,
  ErrorMessageComponent: g,
  keepLoadingOn: u = !1,
  children: m
}) => {
  const {
    loading: x,
    is2fa: d,
    error: w,
    loginUrl: y
  } = ir(e), C = {
    ...l
  };
  l.button && (C.button = {
    ...l.button,
    url: y
  }), l.secondaryButton && (C.secondaryButton = {
    ...l.secondaryButton,
    url: t
  });
  const E = {
    ...c
  };
  return c.button && (E.button = {
    ...c.button,
    url: y
  }), c.secondaryButton && (E.secondaryButton = {
    ...c.secondaryButton,
    url: t
  }), L(() => {
    x || (w ? o && window.history.replaceState(null, "", o) : d ? a && a() : i && window.history.replaceState(null, "", i));
  }, [x, w, d, o, i, a]), /* @__PURE__ */ b(z, {
    children: [/* @__PURE__ */ n(p, {
      open: x || d && u,
      loadingText: s
    }), !x && /* @__PURE__ */ n(z, {
      children: d ? m : w ? /* @__PURE__ */ n(g, {
        ...C
      }) : /* @__PURE__ */ n(g, {
        ...E
      })
    })]
  });
}, ar = 62, sr = 130, dt = ({
  children: e,
  href: t,
  sx: o,
  ...i
}) => t ? /* @__PURE__ */ n(G, {
  ...i,
  href: t,
  target: "_blank",
  rel: "noopener noreferrer",
  underline: "none",
  noWrap: !0,
  sx: B({
    color: "inherit"
  }, o),
  children: e
}) : /* @__PURE__ */ n(z, {
  children: e
}), kn = ({
  image: e,
  line1: t,
  line2: o,
  url: i,
  isApp: a,
  smallLogo: s = !1,
  sx: l
}) => /* @__PURE__ */ b(kt, {
  sx: B([{
    gridTemplateColumns: "72px auto",
    rowGap: 0.5,
    alignItems: "center"
  }, s && {
    gridTemplateColumns: "40px auto",
    mb: 2
  }], l),
  children: [/* @__PURE__ */ n(dt, {
    href: i,
    sx: [Boolean(i) && {
      gridRow: "1 / 3"
    }],
    children: /* @__PURE__ */ n(h, {
      ...e,
      component: "img",
      loading: "lazy",
      sx: [{
        gridRow: "1 / 3",
        display: "block",
        width: "72px",
        height: "40px",
        maxWidth: 1,
        objectFit: "contain"
      }, s && {
        width: "40px"
      }]
    })
  }), /* @__PURE__ */ n(dt, {
    href: i,
    children: /* @__PURE__ */ n(R, {
      noWrap: !0,
      sx: {
        fontWeight: a ? "bold" : "normal"
      },
      children: t
    })
  }), /* @__PURE__ */ n(dt, {
    href: i,
    children: /* @__PURE__ */ n(R, {
      noWrap: !0,
      sx: {
        fontWeight: a ? "normal" : "bold"
      },
      children: o
    })
  })]
}), pt = ({
  logos: e
}) => /* @__PURE__ */ n(kt, {
  sx: ({
    breakpoints: t
  }) => ({
    [t.up(640)]: {
      gridTemplateColumns: "1fr 1fr"
    }
  }),
  children: e.map((t) => /* @__PURE__ */ n(kn, {
    ...t
  }, t.id))
}), je = ({
  id: e,
  images: t,
  sx: o
}) => {
  const {
    breakpoints: i
  } = mn(), a = be(i.up("xl"));
  return /* @__PURE__ */ n(Jo, {
    id: e,
    spaceBetween: 16,
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    freeMode: !0,
    breakpoints: {
      [i.values.sm]: {
        slidesPerView: 3.5,
        slidesPerGroup: 1,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        freeMode: !0
      },
      640: {
        slidesPerView: 3.5,
        slidesPerGroup: 1,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
        freeMode: !0
      },
      [i.values.xl]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        freeMode: !1
      }
    },
    arrows: a ? {
      sideOffset: -28
    } : !1,
    componentSx: {
      container: B({
        position: "relative",
        mb: 4,
        mx: -2,
        [i.between(640, "xl")]: {
          mx: -4
        },
        [i.up("xl")]: {
          mx: 0
        }
      }, o),
      root: {
        mb: -1.5,
        pb: 1.5
      },
      navigation: {
        "& .prev, & .next": {
          top: "calc(50% - 18px)"
        }
      }
    },
    children: t.map(({
      src: s,
      alt: l
    }) => /* @__PURE__ */ n(Zo, {
      children: /* @__PURE__ */ n(h, {
        sx: {
          display: "flex",
          overflow: "hidden",
          borderRadius: 1,
          boxShadow: 1
        },
        children: /* @__PURE__ */ n(h, {
          component: "img",
          src: s,
          alt: l,
          loading: "lazy",
          sx: {
            width: 640,
            maxWidth: 1,
            aspectRatio: "16 / 9",
            objectFit: "cover"
          }
        })
      })
    }, s))
  });
}, ut = ({
  heading: e,
  count: t,
  countTemplate: o
}) => /* @__PURE__ */ b(R, {
  variant: "h3",
  sx: {
    mb: 2
  },
  children: [e, t !== void 0 && o && /* @__PURE__ */ b(z, {
    children: ["\xA0", /* @__PURE__ */ n(R, {
      component: "span",
      sx: {
        fontSize: "inherit",
        fontWeight: "normal"
      },
      children: Ae(t > 1 ? o.plural : o.singular, {
        count: t
      })
    })]
  })]
});
Ne(({
  content: e,
  onSectionInView: t
}, o) => {
  const {
    contentId: i,
    type: a,
    header: s,
    appHeader: l,
    channels: c,
    posters: p,
    apps: g
  } = e, [u, m] = k("0px"), x = W(({
    tabId: d,
    contentId: w
  }) => Io((y) => y && (t == null ? void 0 : t(d, w)), 50), [t]);
  return L(() => {
    const d = ar + sr + 24 + 1;
    m(`-${d}px 0px -${window.innerHeight - d}px 0px`);
  }, []), /* @__PURE__ */ n(h, {
    component: "section",
    ref: o,
    children: /* @__PURE__ */ n(To, {
      rootMargin: u,
      onChange: x(e),
      children: /* @__PURE__ */ n(_o, {
        name: i,
        children: /* @__PURE__ */ b(h, {
          ref: o,
          children: [a === "vernacular" && /* @__PURE__ */ n(je, {
            id: i,
            images: p
          }), /* @__PURE__ */ n(ut, {
            ...s
          }), a === "app" ? g.map((d, w, y) => /* @__PURE__ */ b("div", {
            children: [/* @__PURE__ */ n(kn, {
              ...d.logo,
              smallLogo: !0
            }), /* @__PURE__ */ n(je, {
              id: d.logo.id,
              images: d.posters,
              sx: [w === y.length - 1 && {
                mb: 0
              }]
            })]
          }, d.logo.id)) : a === "content" ? /* @__PURE__ */ b(z, {
            children: [/* @__PURE__ */ n(je, {
              id: i,
              images: p
            }), /* @__PURE__ */ n(pt, {
              logos: c
            })]
          }) : a === "vernacular" ? /* @__PURE__ */ b(z, {
            children: [/* @__PURE__ */ n(pt, {
              logos: c
            }), l && g.length > 0 && /* @__PURE__ */ b(h, {
              sx: {
                mt: 8
              },
              children: [g.map((d) => /* @__PURE__ */ b("div", {
                children: [/* @__PURE__ */ n(ut, {
                  heading: d.logo.line1
                }), /* @__PURE__ */ n(je, {
                  id: d.logo.id,
                  images: d.posters
                })]
              }, d.logo.id)), /* @__PURE__ */ n(ut, {
                ...l
              }), /* @__PURE__ */ n(pt, {
                logos: g.map((d) => d.logo)
              })]
            })]
          }) : null]
        })
      })
    })
  });
});
const oe = {
  header: {
    logo: {
      image: "https://acm-assets.eco.astro.com.my/images/astro-logo-white.svg",
      name: "Astro",
      url: ""
    },
    divisions: [
      { name: "Consumer", url: "" },
      { name: "Business", url: "" },
      { name: "Corporate", url: "" }
    ],
    navItems: [
      { name: "Astro TV Packs" },
      { name: "Astro Fibre" },
      { name: "Products & Services" },
      { name: "TV Guide" },
      { name: "Promotions" },
      { name: "My Account" },
      { name: "Support" }
    ],
    mobileDrawer: {
      title: ""
    },
    search: {
      endpoint: "",
      navItem: "Search",
      placeholder: ""
    },
    languages: [
      { id: "en", name: "English", shortName: "EN" },
      { id: "bm", name: "Bahasa Malaysia", shortName: "BM" }
    ],
    sso: {
      navItem: "Login",
      navItemAuthenticated: "Profile",
      manageProfile: "",
      logout: ""
    },
    bcp: {
      icon: "",
      iconAlt: "",
      backgroundColor: "#d8d8d8",
      textColor: "common.white",
      linkColor: "#e6007d",
      closeButtonColor: "",
      cookie: {
        duration: 0
      },
      timerUnits: {
        shortForm: {
          day: "",
          hour: "",
          minute: "",
          second: "",
          separator: ""
        },
        fullForm: {
          day: "",
          hour: "",
          minute: "",
          second: "",
          separator: ""
        }
      }
    },
    ourBrands: { name: "Our Brands" },
    uxf: {
      logoutUrl: "",
      whitelistedAddress: []
    },
    ulm: {
      urlParams: {
        domain: "",
        pathname: "",
        params: {}
      },
      client: "",
      sessionApi: {
        refresh: "",
        getUser: ""
      },
      expiry: {
        refreshSession: 0,
        startSession: 0
      }
    },
    locales: {
      bm: {
        divisions: [{ name: "Pengguna" }, { name: "Perniagaan" }, { name: "Korporat" }],
        navItems: [
          { name: "Pek Astro" },
          { name: "Produk & Perkhidmatan" },
          { name: "Panduan TV" },
          { name: "Promosi" },
          { name: "Akaun Saya" },
          { name: "Bantuan" }
        ],
        search: {
          navItem: "Cari"
        },
        sso: {
          navItem: "Log masuk",
          navItemAuthenticated: "Profil"
        },
        ourBrands: {
          name: "Jenama kami"
        }
      }
    }
  },
  footer: {
    apps: {
      heading: "",
      storeBadges: [],
      items: []
    },
    columns: [],
    complaint: {
      image: "",
      name: "",
      url: ""
    },
    contactUsHtml: "",
    socialIcons: [],
    footerLinks: [],
    copyrightHtml: "",
    locales: {}
  },
  liveChat: {
    needHelp: "",
    bubbleTitle: "",
    bubbleDesc: "",
    scrollLengthToAppearBubbleInPixels: 400,
    idleTimeToShowBubble: 10,
    whatsAppLink: "",
    whatsAppImage: "",
    defaultShortCode: "",
    urlsToEnableLiveChat: [],
    locales: {}
  },
  entryModal: {
    closeIconColor: "",
    image: {
      name: "",
      url: "",
      mobileImg: {
        image: "",
        width: 0,
        height: 0
      },
      desktopImg: {
        image: "",
        width: 0,
        height: 0
      }
    },
    applicablePortals: [],
    cookieDuration: 0,
    userSegment: 0
  }
}, cn = {
  production: {
    df: "https://digital-fortress-assets.eco.astro.com.my/prod/config/XdovZqB9Rg/config.json",
    bcp: {
      en: "https://contenthub-api.eco.astro.com.my/bcp/message-config-en.json",
      bm: "https://contenthub-api.eco.astro.com.my/bcp/message-config-bm.json"
    },
    crossPromo: "https://digital-fortress-assets.eco.astro.com.my/prod/config/6rPy3LBn0W/config.json"
  },
  staging: {
    df: "https://digital-fortress-dev.eco.astro.com.my/dev/config/N8evxoJBVL/config.json",
    bcp: {
      en: "https://contenthub-api-stg.eco.astro.com.my/bcp/message-config-en.json",
      bm: "https://contenthub-api-stg.eco.astro.com.my/bcp/message-config-bm.json"
    },
    crossPromo: "https://digital-fortress-assets.eco.astro.com.my/prod/config/6rPy3LBn0W/config.json"
  },
  qalab: {
    df: "https://digital-fortress-dev.eco.astro.com.my/dev/config/6rPy3LqBn0/config.json",
    bcp: {
      en: "https://contenthub-api-stg.eco.astro.com.my/bcp/message-config-en.json",
      bm: "https://contenthub-api-stg.eco.astro.com.my/bcp/message-config-bm.json"
    },
    crossPromo: "https://digital-fortress-assets.eco.astro.com.my/prod/config/6rPy3LBn0W/config.json"
  }
}, qe = fn({
  hasFetchedConfig: !1,
  config: oe,
  endpoints: {
    df: "",
    bcp: {
      en: "",
      bm: ""
    },
    crossPromo: ""
  },
  environment: null,
  language: gn
});
function Ke() {
  const { config: e } = Ge(qe);
  return e;
}
function U() {
  return Ke().header;
}
function ae() {
  return Ke().footer;
}
function Rt() {
  return Ke().liveChat;
}
function lr() {
  return Ke().entryModal;
}
function Sn() {
  const { endpoints: e } = Ge(qe);
  return e;
}
function At() {
  const { language: e } = Ge(qe);
  return e;
}
const Hi = ({
  environment: e,
  children: t
}) => {
  const o = e === "staging" || e === "qalab" ? e : "production", [i, a] = k(gn), [s, l] = k(!1), [c, p] = k(oe), [g, u] = k(oe);
  L(() => {
    const x = cn[o].df;
    fetch(x).then((d) => d.json()).then((d) => {
      var $, se, V, le;
      const {
        response: w
      } = d, y = ($ = Ee("header", w)) != null ? $ : oe.header, C = (se = Ee("footer", w)) != null ? se : oe.footer, E = (V = Ee("livechat", w)) != null ? V : oe.liveChat, I = (le = Ee("entry_modal", w)) != null ? le : oe.entryModal;
      p({
        header: y,
        footer: C,
        liveChat: E,
        entryModal: I
      }), l(!0);
    }).catch((d) => {
      console.error("Failed to fetch nav config", d == null ? void 0 : d.message);
    });
  }, [o]), L(() => {
    const x = (d) => {
      const w = d.detail;
      w && bn(w) && a(w);
    };
    return window.addEventListener(mt, x), () => {
      window.removeEventListener(mt, x);
    };
  }, []), L(() => {
    s && u((x) => {
      const {
        locales: d = {},
        ...w
      } = c.header, {
        locales: y = {},
        ...C
      } = c.footer, {
        locales: E = {},
        ...I
      } = c.liveChat;
      return {
        ...x,
        header: lt(w, d[i]),
        footer: lt(C, y[i]),
        liveChat: lt(I, E[i]),
        entryModal: c.entryModal
      };
    });
  }, [s, c, i]);
  const m = hn(() => ({
    hasFetchedConfig: s,
    config: g,
    endpoints: cn[o],
    environment: o,
    language: i
  }), [s, g, o, i]);
  return /* @__PURE__ */ n(qe.Provider, {
    value: m,
    children: t
  });
}, En = _e(
  {
    breakpoints: St,
    palette: Et,
    spacing: It,
    shape: _t,
    typography: Tt
  },
  {
    components: {
      MuiContainer: {
        defaultProps: {
          maxWidth: "xl"
        },
        styleOverrides: {
          root: ({ theme: e }) => ({
            paddingLeft: "16px",
            paddingRight: "16px",
            [e.breakpoints.up("sm")]: {
              paddingLeft: "16px",
              paddingRight: "16px"
            },
            [e.breakpoints.up("xl")]: {
              paddingLeft: "72px",
              paddingRight: "72px"
            }
          })
        }
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            margin: 0
          }
        }
      },
      MuiIconButton: {
        defaultProps: {
          disableRipple: !0,
          size: "large"
        },
        styleOverrides: {
          root: {
            padding: 12,
            color: "inherit",
            ":hover": {
              backgroundColor: "transparent"
            }
          }
        }
      },
      MuiLink: {
        defaultProps: {
          underline: "none"
        }
      }
    },
    palette: {
      primary: {
        main: "#e6007d",
        dark: "#e72647"
      },
      grey: {
        100: "#f5f5f5",
        600: "#707070"
      }
    },
    typography: {
      h1: {
        fontSize: "28px",
        lineHeight: "34px"
      },
      h2: {
        fontSize: "24px",
        lineHeight: "30px"
      },
      h3: {
        fontSize: "20px",
        lineHeight: "26px"
      },
      h4: {
        fontSize: "16px",
        lineHeight: "22px"
      },
      h5: {
        fontSize: "14px",
        lineHeight: "20px"
      },
      body1: {
        fontSize: "16px",
        lineHeight: "22px"
      },
      body2: {
        fontSize: "14px",
        lineHeight: "20px"
      },
      caption: {
        fontSize: "12px",
        lineHeight: "18px"
      },
      button: {
        fontSize: "16px",
        lineHeight: 1,
        fontWeight: "bold",
        textTransform: "none"
      }
    }
  }
), _n = vt(En);
function D(e) {
  return `acm-header${e ? `__${e}` : ""}`;
}
function dn(e, t) {
  const o = `noopener${e == null || e ? " noreferrer" : ""}${t ? " nofollow" : ""}`;
  return {
    target: "_blank",
    rel: o
  };
}
function xe(e) {
  return e.map(({ newTab: t, ...o }) => ({
    ...o,
    newTabAttributes: t && typeof t != "boolean" ? dn(t.noReferrer, t.noFollow) : t ? dn() : void 0
  }));
}
function he(e, t) {
  var o;
  return (o = t == null ? void 0 : t.find(({ names: i }) => i.some((a) => a === e))) == null ? void 0 : o.callback;
}
function Z(e, t, o = !1) {
  const i = new Date().getTime(), a = new Date(e).getTime() - i;
  let s;
  switch (t) {
    case "day":
      s = a / (24 * 60 * 60 * 1e3);
      break;
    case "hour":
      s = a % (24 * 60 * 60 * 1e3) / (1e3 * 60 * 60);
      break;
    case "minute":
      s = a % (60 * 60 * 1e3) / (1e3 * 60);
      break;
    case "second":
      s = a % (60 * 1e3) / 1e3;
      break;
    default:
      s = 0;
      break;
  }
  return s < 1 ? o ? null : "00" : Math.floor(s).toString().padStart(2, "0");
}
const In = (e) => {
  const [t, o] = k(Z(e, "day", !0)), [i, a] = k(Z(e, "hour")), [s, l] = k(Z(e, "minute")), [c, p] = k(Z(e, "second"));
  return L(() => {
    const g = setInterval(() => {
      const u = Z(e, "day", !0), m = Z(e, "hour"), x = Z(e, "minute"), d = Z(e, "second");
      o(u), a(m), l(x), p(d);
    }, 1e3);
    return () => clearInterval(g);
  }, []), [t, i, s, c];
}, ze = ({
  timer: e,
  unit: t
}) => /* @__PURE__ */ b(h, {
  sx: {
    textAlign: "center"
  },
  children: [/* @__PURE__ */ n(R, {
    component: "span",
    sx: {
      fontSize: "2rem",
      lineHeight: "2.125rem",
      fontWeight: 800
    },
    children: e
  }), /* @__PURE__ */ n(R, {
    component: "span",
    sx: {
      display: "block",
      fontSize: "0.75rem",
      lineHeight: "0.875rem",
      fontWeight: 800
    },
    children: t
  })]
}), ft = ({
  separator: e
}) => /* @__PURE__ */ n(R, {
  variant: "h4",
  component: "span",
  sx: {
    mx: 2
  },
  children: e
}), cr = ({
  endTime: e,
  units: t,
  textColor: o = "auto"
}) => {
  const [i, a, s, l] = In(e);
  return /* @__PURE__ */ b(ge, {
    sx: {
      alignItems: "center",
      color: o
    },
    children: [i && /* @__PURE__ */ b(z, {
      children: [/* @__PURE__ */ n(ze, {
        unit: t.day,
        timer: i
      }), /* @__PURE__ */ n(ft, {
        separator: t.separator
      })]
    }), a && /* @__PURE__ */ n(ze, {
      unit: t.hour,
      timer: a
    }), /* @__PURE__ */ n(ft, {
      separator: t.separator
    }), s && /* @__PURE__ */ n(ze, {
      unit: t.minute,
      timer: s
    }), /* @__PURE__ */ n(ft, {
      separator: t.separator
    }), l && /* @__PURE__ */ n(ze, {
      unit: t.second,
      timer: l
    })]
  });
}, Tn = ({
  endTime: e,
  units: t,
  textColor: o = "auto"
}) => {
  const [i, a, s, l] = In(e);
  return /* @__PURE__ */ b(R, {
    sx: {
      display: "inline",
      color: o
    },
    children: [i && /* @__PURE__ */ b(z, {
      children: [i, t.day, t.separator]
    }), a, t.hour, t.separator, s, t.minute, t.separator, l, t.second]
  });
}, dr = ({
  config: {
    title: e,
    description: t,
    logoImageUrl: o,
    backgroundImageUrl: i,
    showCountdownTimer: a,
    endTime: s
  },
  handleExited: l
}) => {
  const [c, p] = k(!1), {
    bcp: {
      iconAlt: g,
      textColor: u,
      linkColor: m,
      closeButtonColor: x,
      timerUnits: d
    }
  } = U(), w = () => p(!1);
  return L(() => {
    requestAnimationFrame(() => p(!0));
  }, []), /* @__PURE__ */ n(yt, {
    id: D("bcp-banner"),
    component: "aside",
    in: c,
    timeout: 200,
    onExited: l,
    children: /* @__PURE__ */ n(h, {
      sx: {
        backgroundImage: `url("${i}")`,
        backgroundSize: "cover"
      },
      children: /* @__PURE__ */ b(ie, {
        sx: {
          display: "flex",
          alignItems: {
            xs: "flex-start",
            xl: "center"
          }
        },
        children: [/* @__PURE__ */ b(ge, {
          sx: {
            justifyContent: "center",
            alignItems: "center",
            py: {
              xs: 1,
              xl: 0
            },
            mr: "auto",
            ml: {
              xs: "auto",
              xl: "0"
            }
          },
          children: [/* @__PURE__ */ n(h, {
            component: "img",
            src: o,
            alt: g,
            sx: {
              mr: {
                xs: 2,
                xl: 3
              },
              alignSelf: "center"
            },
            loading: "lazy"
          }), /* @__PURE__ */ b(h, {
            id: D("bcp-message"),
            sx: {
              mr: {
                xs: 2,
                xl: 0
              },
              py: {
                xs: 0,
                xl: 2
              },
              color: u,
              "& a": {
                color: m || "primary.main",
                fontWeight: "bold",
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline"
                }
              }
            },
            children: [e && /* @__PURE__ */ n(R, {
              component: "strong",
              variant: "h4",
              sx: {
                display: {
                  xl: "inline"
                },
                mr: {
                  xl: 1
                }
              },
              children: e
            }), /* @__PURE__ */ n(R, {
              dangerouslySetInnerHTML: {
                __html: t
              },
              sx: {
                display: {
                  xl: "inline"
                }
              }
            }), a && /* @__PURE__ */ n(h, {
              sx: {
                display: {
                  xs: "block",
                  xl: "none"
                },
                mt: 0.25,
                ml: {
                  xl: "auto"
                }
              },
              children: /* @__PURE__ */ n(Tn, {
                textColor: u,
                endTime: s,
                units: d.shortForm
              })
            })]
          })]
        }), /* @__PURE__ */ b(ge, {
          sx: {
            mt: {
              xs: 0.5,
              xl: 0
            }
          },
          children: [a && /* @__PURE__ */ n(h, {
            sx: {
              display: {
                xs: "none",
                xl: "block"
              },
              ml: "auto",
              mx: 4,
              py: 1.5
            },
            children: /* @__PURE__ */ n(cr, {
              textColor: u,
              endTime: s,
              units: d.fullForm
            })
          }), /* @__PURE__ */ n(J, {
            sx: {
              mx: -1.5,
              p: 1.5
            },
            onClick: w,
            children: /* @__PURE__ */ n(ye, {
              htmlColor: x
            })
          })]
        })]
      })
    })
  });
}, pr = ({
  config: {
    title: e,
    description: t,
    backgroundImageUrl: o,
    showCountdownTimer: i,
    endTime: a
  },
  open: s,
  onBannerClick: l
}) => {
  const {
    transitions: c
  } = mn(), {
    bcp: {
      textColor: p,
      linkColor: g,
      timerUnits: u
    }
  } = U(), m = (x) => {
    x.target instanceof HTMLAnchorElement && x.stopPropagation();
  };
  return /* @__PURE__ */ n(bt, {
    id: D("bcp-banner"),
    timeout: {
      enter: c.duration.enteringScreen,
      exit: c.duration.leavingScreen
    },
    in: s,
    children: /* @__PURE__ */ n(h, {
      id: D("bcp-mini-banner"),
      sx: {
        backgroundImage: `url("${o}")`,
        backgroundSize: "cover",
        py: 0.625,
        whiteSpace: "nowrap",
        ":hover": {
          cursor: "pointer"
        }
      },
      onClick: l,
      children: /* @__PURE__ */ b(ie, {
        sx: {
          display: "flex",
          justifyContent: i ? "space-between" : "initial",
          gap: 2
        },
        children: [/* @__PURE__ */ b(h, {
          id: D("bcp-minimal-message"),
          sx: {
            color: p,
            overflow: "hidden",
            textOverflow: "ellipsis",
            "& a": {
              color: g || "primary.main",
              fontWeight: "bold",
              cursor: "pointer",
              ":hover": {
                textDecoration: "underline"
              }
            }
          },
          children: [e && /* @__PURE__ */ n(R, {
            component: "strong",
            variant: "h4",
            sx: {
              mr: 1
            },
            children: e
          }), /* @__PURE__ */ n(R, {
            onClick: m,
            sx: {
              display: {
                xs: "none",
                xl: "inline"
              }
            },
            dangerouslySetInnerHTML: {
              __html: t
            }
          })]
        }), i && /* @__PURE__ */ n(Tn, {
          textColor: p,
          endTime: a,
          units: u.shortForm
        })]
      })
    })
  });
}, ur = () => {
  const [e, t] = k(null), { bcp: o } = Sn(), i = At();
  return L(() => {
    fetch(o[i]).then((a) => a.json()).then((a) => {
      const { response: s } = a, l = Date.now(), c = new Date(s.preDeployment.startTime).getTime(), p = new Date(s.preDeployment.endTime).getTime(), g = new Date(s.deployment.startTime).getTime(), u = new Date(s.deployment.endTime).getTime();
      l >= c && l < p ? t({
        title: s.preDeployment.title,
        description: s.preDeployment.description,
        logoImageUrl: s.preDeployment.logoImageURL,
        backgroundImageUrl: s.preDeployment.backgroundImageURL,
        showCountdownTimer: s.preDeployment.showCountdownTimer,
        endTime: s.preDeployment.endTime
      }) : l >= g && l < u ? t({
        title: s.deployment.title,
        description: s.deployment.description,
        logoImageUrl: s.deployment.logoImageURL,
        backgroundImageUrl: s.deployment.backgroundImageURL,
        showCountdownTimer: s.deployment.showCountdownTimer,
        endTime: s.deployment.endTime
      }) : t(null);
    }).catch((a) => {
      a instanceof Error && Do.error("Failed to fetch BCP message:", a.message);
    });
  }, [o, i]), e;
}, fr = () => {
  const [e, t] = k(), [o, i] = k(!0), {
    bcp: {
      cookie: a
    }
  } = U(), {
    portalRegexes: s
  } = a, l = W(() => {
    a.duration && o && re(tn, 1, a.duration, !1, e);
  }, [a, o, e]);
  return L(() => {
    t(ve(window.location.hostname));
    let p = !0;
    s && (p = (s == null ? void 0 : s.findIndex((g) => g && window.location.href.match(new RegExp(g, "i")))) >= 0), i(p);
  }, [s]), {
    hasUserClosed: Boolean(o && F(tn)),
    handleExited: l
  };
}, hr = ({
  showMinimalBanner: e = !1
}) => {
  const t = ur(), {
    hasUserClosed: o,
    handleExited: i
  } = fr(), a = yn("xl"), s = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  };
  return o || !t ? null : /* @__PURE__ */ b(z, {
    children: [/* @__PURE__ */ n(h, {
      sx: {
        zIndex: ({
          zIndex: l
        }) => l.appBar,
        position: "relative",
        mb: -4
      },
      children: /* @__PURE__ */ n(dr, {
        config: t,
        handleExited: i
      })
    }), (t.title || t.showCountdownTimer || a) && /* @__PURE__ */ n(h, {
      sx: {
        zIndex: ({
          zIndex: l
        }) => l.appBar - 1,
        position: "sticky",
        top: 0
      },
      children: /* @__PURE__ */ n(pr, {
        onBannerClick: s,
        config: t,
        open: e
      })
    })]
  });
}, Rn = fn({
  enableUxf: !1,
  authenticated: !1,
  loginUrl: ""
});
function te() {
  return Ge(Rn);
}
const mr = ({
  children: e,
  ...t
}) => {
  const {
    hideLanguage: o,
    onInit: i,
    onAuth: a,
    onLanguageChange: s
  } = t, {
    uxf: l,
    ulm: c
  } = U(), [p, g] = k(!1), [u, m] = k(""), [x, d] = k(!1), w = W(() => {
    var C;
    return l.whitelistedAddress.includes((C = window.location.hostname) != null ? C : "");
  }, [l]);
  L(() => {
    const C = w(), E = (I) => {
      C || d(!!I.detail);
    };
    return d(C || No()), g(C), window.addEventListener(Ie, E), () => {
      window.removeEventListener(Ie, E);
    };
  }, [w]), L(() => {
    const C = w(), E = Ho(c);
    E && (m(E), i && i({
      ulmUrl: E,
      enableUxf: C
    }), Fo(c).then((I) => {
      a && a(I);
    }).catch((I) => {
      console.error("Failed to refresh session", I == null ? void 0 : I.message);
    }));
  }, [c, i, a, w]), L(() => {
    !o && requestAnimationFrame(() => {
      let C = F(xn);
      if (!C) {
        const [E] = window.location.pathname.split("/").slice(1);
        C = E;
      }
      vn(C, s);
    });
  }, [o, s]);
  const y = hn(() => ({
    ...t,
    enableUxf: p,
    authenticated: x,
    loginUrl: u
  }), [t, p, x, u]);
  return /* @__PURE__ */ n(Rn.Provider, {
    value: y,
    children: e
  });
}, Je = ({
  bold: e,
  boldOnHover: t,
  icon: o,
  text: i,
  sx: a,
  ...s
}) => /* @__PURE__ */ b(z, {
  children: [o, /* @__PURE__ */ n(h, {
    component: "span",
    "data-title": i,
    ...s,
    sx: B([({
      breakpoints: l
    }) => ({
      display: "none",
      ml: o ? 1 : 0,
      typography: "body2",
      letterSpacing: 0.3,
      outline: "none",
      "::before": {
        display: "block",
        content: "attr(data-title)",
        visibility: "hidden",
        overflow: "hidden",
        height: 0,
        fontWeight: "bold",
        letterSpacing: 0.3
      },
      [l.up(480)]: {
        display: "inline-block"
      }
    }), !!e && {
      fontWeight: "bold",
      letterSpacing: "normal",
      textShadow: ({
        palette: l
      }) => `0 0 ${l.common.white}`,
      WebkitFontSmoothing: "subpixel-antialiased"
    }, !!t && {
      "&:hover, &:focus": {
        fontWeight: "bold",
        letterSpacing: "normal",
        textShadow: ({
          palette: l
        }) => `0 0 ${l.common.white}`,
        WebkitFontSmoothing: "subpixel-antialiased"
      }
    }], a),
    children: i
  })]
}), gr = () => /* @__PURE__ */ b(N, {
  viewBox: "0 0 20 20",
  fontSize: "small",
  htmlColor: "#fff",
  children: [/* @__PURE__ */ n("path", {
    d: "M4.67 15.36h-.42A2.25 2.25 0 0 1 2 13.14V4.22A2.23 2.23 0 0 1 4.25 2h11.51A2.23 2.23 0 0 1 18 4.22v8.92a2.23 2.23 0 0 1-2.24 2.22h-6a2.25 2.25 0 0 0-1.72.8L6.49 18",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ n("path", {
    d: "m10.046 7.29-.72 1.789h1.45l-.73-1.79Zm0-3h.33l.13.07h.06l.09.069.08.09v.05l.07.14 2 4.84 1 2.42a.83.83 0 0 1-.11.82.85.85 0 0 1-1.18.14.858.858 0 0 1-.13-.14l-.07-.11-.05-.1-.78-1.9h-2.77l-.77 1.9a.83.83 0 0 1-.44.46h-.209a.84.84 0 0 1-.913-.583.78.78 0 0 1-.026-.307v-.24l1-2.39 2-4.81.08-.15.1-.12.1-.08.12-.07h.29Z"
  })]
}), xr = () => /* @__PURE__ */ n(N, {
  viewBox: "0 0 12 12",
  color: "primary",
  sx: {
    fontSize: "12px"
  },
  children: /* @__PURE__ */ n("path", {
    d: "M4.017 10.97a1.356 1.356 0 0 1-.992-.489l-2.67-3.21a1.59 1.59 0 0 1 .09-2.104A1.3 1.3 0 0 1 2 4.903c.167.089.314.213.428.364l1.648 1.994 5.47-6.73a1.302 1.302 0 0 1 .962-.528 1.296 1.296 0 0 1 1.023.399 1.578 1.578 0 0 1 .119 2.113l-6.482 7.976a1.381 1.381 0 0 1-.993.509l-.159-.03Z"
  })
}), br = ({
  items: e,
  selectedId: t,
  onChange: o
}) => {
  const i = (a) => () => o(a);
  return /* @__PURE__ */ n(h, {
    component: "ul",
    sx: {
      display: "flex",
      flexDirection: "column",
      my: 0,
      p: "8px 0",
      color: "common.white",
      typography: "body1",
      cursor: "default"
    },
    children: e.map(({
      id: a,
      label: s
    }) => /* @__PURE__ */ b(h, {
      component: "li",
      onClick: i(a),
      sx: {
        display: "grid",
        gridTemplateColumns: "auto 16px",
        columnGap: 8,
        my: 0,
        p: "8px 16px",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        ":hover > span:not(.acm-header__selected)": {
          fontWeight: "bold",
          letterSpacing: 0.1,
          textShadow: ({
            palette: l
          }) => `0 0 ${l.primary.contrastText}`,
          WebkitFontSmoothing: "subpixel-antialiased"
        }
      },
      children: [/* @__PURE__ */ n(h, {
        component: "span",
        className: a === t ? "acm-header__selected" : void 0,
        "data-title": s,
        sx: [{
          display: "inline-block",
          width: 1,
          userSelect: "none",
          letterSpacing: 0.4,
          "::before": {
            display: "block",
            content: "attr(data-title)",
            visibility: "hidden",
            overflow: "hidden",
            height: 0,
            fontWeight: "bold",
            letterSpacing: 0.4
          }
        }, a === t && {
          color: "primary.main",
          fontWeight: "bold",
          letterSpacing: 0.1,
          textShadow: ({
            palette: l
          }) => `0 0 ${l.primary.main}`,
          WebkitFontSmoothing: "subpixel-antialiased"
        }],
        children: s
      }), a === t && /* @__PURE__ */ n(xr, {})]
    }, a))
  });
}, An = () => {
  var d, w;
  const {
    languages: e
  } = U(), {
    hideLanguage: t,
    onLanguageChange: o
  } = te(), i = At(), [a, s] = k(!1), l = Re(null), c = () => s(!a), p = () => s(!1), g = (y) => y.stopPropagation(), u = W((y) => {
    s(!1), vn(y, o);
  }, [o]), m = (w = (d = e.find((y) => y.id === i)) == null ? void 0 : d.shortName) != null ? w : "", x = e.map((y) => ({
    id: y.id,
    label: y.name
  }));
  return t ? null : /* @__PURE__ */ b(h, {
    id: D("language-switcher"),
    "aria-describedby": D("language-switcher-menu"),
    onClick: c,
    sx: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      height: 40,
      fontSize: 0,
      color: "common.white",
      cursor: "pointer",
      outline: "none",
      userSelect: "none"
    },
    children: [/* @__PURE__ */ n(h, {
      ref: l,
      sx: {
        position: "absolute",
        top: 0,
        right: 0,
        height: {
          xs: 1,
          lg: "calc(100% + 8px)"
        }
      }
    }), /* @__PURE__ */ n(Je, {
      text: m,
      bold: a,
      icon: /* @__PURE__ */ n(gr, {})
    }), /* @__PURE__ */ n(wt, {
      id: D("language-switcher-menu"),
      open: a,
      onClose: p,
      anchorEl: l.current,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      elevation: 0,
      hideBackdrop: !0,
      sx: {
        "& .MuiPopover-paper": {
          bgcolor: "common.black",
          borderRadius: 1,
          boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1)"
        }
      },
      children: /* @__PURE__ */ n("div", {
        onClick: g,
        "aria-hidden": "true",
        children: /* @__PURE__ */ n(br, {
          items: x,
          selectedId: i,
          onChange: u
        })
      })
    })]
  });
}, Ze = "navEvent", Xe = "ACM Header", K = (e, t) => {
  ee({
    event: Ze,
    content_type: Xe,
    content_list_type: "Main Navigation",
    content_title: e,
    content_id: t != null ? t : "NA"
  });
}, vr = (e) => {
  ee({
    event: Ze,
    content_type: Xe,
    content_title: e,
    content_list_type: "Search"
  });
}, yr = (e, t) => {
  t && ee({
    event: Ze,
    content_type: Xe,
    content_list_type: "Consumer Navigation",
    content_title: e,
    content_id: t
  });
}, Te = (e, t) => {
  ee({
    event: Ze,
    content_type: Xe,
    content_list_type: "Mobile Navigation",
    content_title: e,
    content_id: t != null ? t : "NA"
  });
}, wr = () => /* @__PURE__ */ b(N, {
  viewBox: "0 0 20 20",
  fontSize: "small",
  children: [/* @__PURE__ */ n("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M17.2 18a.8.8 0 01-.795-.706l-.009-.235a2.4 2.4 0 00-2.255-2.259H6a2.4 2.4 0 00-2.4 2.4.8.8 0 01-1.6 0 4 4 0 013.827-4H14a4 4 0 014 4 .8.8 0 01-.8.8zM10 11.6a4.8 4.8 0 114.8-4.8 4.805 4.805 0 01-4.8 4.8zm0-8a3.2 3.2 0 103.2 3.2A3.2 3.2 0 0010 3.6z"
  })]
}), Cr = ({
  onItemClick: e
}) => {
  const {
    sso: t,
    ulm: o,
    uxf: i
  } = U(), {
    enableUxf: a,
    onLogout: s,
    shouldOverrideLogout: l
  } = te(), c = (d) => () => {
    K(t.manageProfile, d), e();
  }, p = () => {
    if (K(t.logout), !l) {
      if (a) {
        e(), s == null || s();
        return;
      }
      $o();
    }
    e(), s == null || s();
  }, g = {
    display: "inline-block",
    width: 1,
    m: 0,
    py: 1,
    px: 2,
    color: "inherit",
    cursor: "pointer",
    userSelect: "none",
    letterSpacing: 0.4,
    ":hover": {
      fontWeight: "bold",
      letterSpacing: 0.1,
      textShadow: ({
        palette: d
      }) => `0 0 ${d.common.white}`,
      WebkitFontSmoothing: "subpixel-antialiased"
    },
    "::before": {
      display: "block",
      content: "attr(data-title)",
      visibility: "hidden",
      overflow: "hidden",
      height: 0,
      fontWeight: "bold",
      letterSpacing: 0.4
    }
  }, u = (d) => ({
    "data-title": d,
    sx: g
  }), m = a ? i.logoutUrl : `${o.urlParams.domain}/profile`, x = [{
    id: "headerAvatarManageProfile",
    text: t.manageProfile,
    href: m,
    onClick: c(m)
  }, {
    id: "headerAvatarLogout",
    text: t.logout,
    href: !l && a ? i.logoutUrl : void 0,
    onClick: p
  }];
  return /* @__PURE__ */ n(h, {
    component: "ul",
    sx: {
      display: "flex",
      flexDirection: "column",
      my: 0,
      py: 1,
      px: 0,
      color: "common.white",
      typography: "body1",
      textAlign: "right",
      cursor: "default",
      "& > li": {
        m: 0
      }
    },
    children: x.map(({
      href: d,
      id: w,
      onClick: y,
      text: C
    }) => /* @__PURE__ */ n(h, {
      component: "li",
      onClick: y,
      ...d ? {} : u(C),
      children: d ? /* @__PURE__ */ n(G, {
        href: d,
        ...u(C),
        children: C
      }) : C
    }, w))
  });
}, Pn = () => {
  const {
    sso: {
      navItem: e,
      navItemAuthenticated: t
    }
  } = U(), {
    authenticated: o,
    loginUrl: i,
    onLogin: a
  } = te(), s = Re(null), [l, c] = k(!1), p = W(() => {
    o ? c((d) => !d) : (K("Login"), a && a(), Uo(i));
  }, [o, i, a]), g = () => c(!1), u = (d) => d.stopPropagation(), m = o ? "headerProfile" : "headerLogin", x = o ? t : e;
  return /* @__PURE__ */ b(h, {
    id: m,
    "aria-describedby": D("profile-menu"),
    onClick: p,
    sx: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      height: 40,
      fontSize: 0,
      color: "common.white",
      cursor: "pointer",
      outline: "none",
      userSelect: "none"
    },
    children: [/* @__PURE__ */ n(h, {
      ref: s,
      sx: {
        position: "absolute",
        top: 0,
        right: 0,
        height: {
          xs: 1,
          lg: "calc(100% + 8px)"
        }
      }
    }), /* @__PURE__ */ n(Je, {
      text: x,
      bold: l && o,
      icon: /* @__PURE__ */ n(wr, {})
    }), /* @__PURE__ */ n(wt, {
      id: D("profile-menu"),
      open: l,
      onClose: g,
      anchorEl: s.current,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      elevation: 0,
      hideBackdrop: !0,
      sx: {
        "& .MuiPopover-paper": {
          bgcolor: "common.black",
          borderRadius: 1,
          boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1)",
          fontFamily: "inherit"
        }
      },
      children: /* @__PURE__ */ n("div", {
        onClick: u,
        "aria-hidden": "true",
        children: /* @__PURE__ */ n(Cr, {
          onItemClick: g
        })
      })
    })]
  });
}, kr = ({
  title: e,
  description: t,
  url: o
}) => /* @__PURE__ */ b(h, {
  sx: {
    display: "flex",
    flexDirection: "column",
    ml: 1
  },
  children: [/* @__PURE__ */ n(R, {
    variant: "h2",
    sx: {
      m: 0,
      mb: 0.5,
      fontSize: "16px",
      lineHeight: 1
    },
    children: e
  }), /* @__PURE__ */ n(R, {
    sx: {
      fontSize: "13px",
      lineHeight: "16px"
    },
    children: t
  }), /* @__PURE__ */ n(R, {
    sx: {
      fontSize: "13px",
      mt: "auto"
    },
    children: o
  })]
}), Sr = ({
  thumbnail: e,
  title: t
}) => /* @__PURE__ */ b(h, {
  sx: {
    position: "relative",
    flexBasis: 120,
    minWidth: 120,
    minHeight: 120,
    display: "grid",
    placeItems: "center",
    "& > div": {
      position: "absolute",
      display: "grid",
      placeItems: "center"
    }
  },
  children: [/* @__PURE__ */ n(h, {
    sx: {
      top: 2,
      left: 2,
      width: "calc(100% - 4px)",
      height: "calc(100% - 4px)",
      bgcolor: "grey.900",
      borderRadius: 0.5
    },
    children: /* @__PURE__ */ n("img", {
      src: "https://acm-assets.eco.astro.com.my/images/placeholder_image.svg",
      alt: "Placeholder",
      width: 34,
      height: 24,
      loading: "lazy"
    })
  }), /* @__PURE__ */ n(h, {
    sx: {
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      bgcolor: "grey.100",
      "& > img": {
        borderRadius: 0.5
      }
    },
    children: /* @__PURE__ */ n("img", {
      src: e,
      alt: t,
      width: 120,
      height: 120,
      loading: "lazy"
    })
  })]
}), Er = ({
  products: e
}) => /* @__PURE__ */ n(h, {
  sx: {
    display: "grid",
    gridTemplateColumns: {
      sm: "repeat(2, 1fr)",
      lg: "repeat(3, 1fr)"
    },
    gap: 2
  },
  children: e.map(({
    thumbnail: t,
    title: o,
    description: i,
    external_link: a
  }) => /* @__PURE__ */ n("a", {
    id: `crossPromo${o.replace(/\s*\W*/g, "")}`,
    href: a,
    target: "_blank",
    rel: "noopener noreferrer",
    children: /* @__PURE__ */ b(h, {
      sx: {
        display: "flex",
        p: 1,
        bgcolor: "common.white",
        borderRadius: 0.5,
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)"
      },
      children: [/* @__PURE__ */ n(Sr, {
        thumbnail: t,
        title: o
      }), /* @__PURE__ */ n(kr, {
        title: o,
        description: i,
        url: a
      })]
    })
  }, o))
}), _r = ({
  title: e,
  logo: t
}) => /* @__PURE__ */ b(h, {
  component: "header",
  sx: {
    display: "flex",
    alignItems: "center",
    height: 33,
    mb: 4
  },
  children: [/* @__PURE__ */ n(R, {
    variant: "h1",
    sx: {
      fontSize: "22px",
      fontWeight: "bold",
      lineHeight: "28px"
    },
    children: e
  }), /* @__PURE__ */ n(h, {
    component: "img",
    src: t,
    alt: e,
    width: 56.4,
    height: 24,
    sx: {
      height: 24,
      ml: "11.2px"
    }
  })]
});
var X = /* @__PURE__ */ ((e) => (e[e.Idle = 0] = "Idle", e[e.Loading = 1] = "Loading", e[e.Failed = 2] = "Failed", e[e.Success = 3] = "Success", e))(X || {});
const Ln = ({
  open: e,
  onClose: t
}) => {
  const {
    crossPromo: o
  } = Sn(), i = At(), [a, s] = k(!1), [l, c] = k(X.Idle), [p, g] = k({
    title: {
      en: "",
      bm: ""
    },
    logo: "",
    products: []
  }), {
    title: u,
    logo: m
  } = p, x = u[i], d = () => s(!1), w = W(t, [t]);
  return L(() => {
    c(X.Loading), fetch(o).then((y) => y.json()).then((y) => {
      const C = Ee("cross_promotion", y.response);
      C ? (g((E) => ({
        ...E,
        title: {
          en: C.title,
          bm: C.titleLocales.ms
        },
        logo: C.titleLogoUrl,
        products: C.products
      })), c(X.Success)) : c(X.Failed);
    }).catch((y) => {
      console.error("Failed to load brands", y == null ? void 0 : y.message), c(X.Failed);
    });
  }, [o]), L(() => {
    e && s(!0);
  }, [e]), /* @__PURE__ */ n(Pe, {
    id: D("brands"),
    open: a,
    onClose: d,
    fullScreen: !0,
    TransitionProps: {
      onExited: w
    },
    sx: {
      "& .MuiDialog-paper": {
        bgcolor: "grey.100",
        color: "text.primary"
      }
    },
    children: /* @__PURE__ */ b(ie, {
      sx: {
        pt: 2,
        pb: 4
      },
      children: [/* @__PURE__ */ n(h, {
        sx: {
          textAlign: "right"
        },
        children: /* @__PURE__ */ n(J, {
          edge: "end",
          onClick: d,
          children: /* @__PURE__ */ n(ye, {})
        })
      }), /* @__PURE__ */ n(_r, {
        title: x,
        logo: m
      }), l === X.Failed ? /* @__PURE__ */ n(R, {
        children: "Something went wrong, please try again later."
      }) : l === X.Success ? /* @__PURE__ */ n(Er, {
        products: p.products
      }) : null]
    })
  });
}, pn = ({
  bold: e,
  id: t,
  name: o,
  newTabAttributes: i,
  onClick: a,
  url: s
}) => /* @__PURE__ */ n(h, {
  component: "li",
  sx: {
    display: "flex",
    alignItems: "center",
    height: 40,
    fontSize: 0,
    color: "common.white",
    cursor: "pointer",
    userSelect: "none"
  },
  children: /* @__PURE__ */ n("a", {
    id: t,
    href: s,
    onClick: a,
    ...i,
    children: /* @__PURE__ */ n(Je, {
      text: o,
      bold: e,
      boldOnHover: !0,
      sx: {
        lineHeight: "40px"
      }
    })
  })
}), Ir = ({
  divisions: e,
  ourBrands: t
}) => {
  const [o, i] = k(!1), [a, s] = k(0), l = xe(e), c = () => i(!1), p = (u, m, x) => (d) => {
    K(u, m), x && !x() && d.preventDefault();
  }, g = W((u) => {
    u.preventDefault(), i(!0), K(t.name);
  }, [t.name]);
  return L(() => {
    const u = l.findIndex((m) => m.regex && RegExp(m.regex, "i").test(window.location.href));
    u >= 0 && s(u);
  }, [l]), /* @__PURE__ */ n("nav", {
    children: /* @__PURE__ */ b(h, {
      component: "ul",
      sx: {
        display: "grid",
        gridAutoFlow: "column",
        gap: 3,
        height: 40,
        p: 0
      },
      children: [l.map(({
        name: u,
        url: m,
        newTabAttributes: x,
        callback: d
      }, w) => /* @__PURE__ */ n(pn, {
        id: `headerNavigation${u.replace(/\s*\W*/g, "")}`,
        name: u,
        url: m,
        newTabAttributes: x,
        onClick: p(u, m, d),
        bold: w === a
      }, u)), /* @__PURE__ */ n(pn, {
        id: "headerCrossPromo",
        name: t.name,
        url: "#",
        onClick: g
      }), o && /* @__PURE__ */ n(Ln, {
        open: o,
        onClose: c
      })]
    })
  });
}, On = (e) => /* @__PURE__ */ b(N, {
  viewBox: "0 0 20 20",
  fontSize: "small",
  htmlColor: "inherit",
  ...e,
  children: [/* @__PURE__ */ n("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M18.1 19a.9.9 0 01-.552-.189l-.085-.075-3.308-3.307A8.012 8.012 0 019.1 17.2a8.1 8.1 0 118.1-8.1 8.011 8.011 0 01-1.771 5.055l3.307 3.308A.9.9 0 0118.1 19zm-9-16.2a6.3 6.3 0 106.3 6.3 6.307 6.307 0 00-6.3-6.3z"
  })]
}), Tr = () => /* @__PURE__ */ b(N, {
  viewBox: "0 0 20 20",
  fontSize: "small",
  sx: {
    "& > path:first-of-type": {
      opacity: {
        lg: 0.4
      }
    }
  },
  children: [/* @__PURE__ */ n("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z",
    fill: "#b2b3b8"
  }), /* @__PURE__ */ n("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.831 13.016-3.014-3.018 3.014 3.018ZM7.337 14.19l2.666-2.669 2.66 2.665a1.075 1.075 0 1 0 1.522-1.522l-2.662-2.665 2.662-2.665.003-.003a1.074 1.074 0 0 0 .003-1.504 1.063 1.063 0 0 0-1.53-.002l-2.658 2.661-2.658-2.66a1.063 1.063 0 0 0-1.524-.005 1.053 1.053 0 0 0 .004 1.517l2.657 2.66-2.658 2.662a1.063 1.063 0 0 0 .003 1.532 1.083 1.083 0 0 0 1.51-.002Z",
    fill: "#fff"
  })]
}), Mn = ({
  mobile: e,
  focus: t,
  sx: o,
  ...i
}) => {
  const a = Re(null), {
    search: s
  } = U(), {
    placeholder: l,
    endpoint: c
  } = s, [p, g] = k(""), u = W((d) => {
    if (d.key === "Enter") {
      d.stopPropagation(), d.preventDefault();
      const {
        value: w
      } = d.currentTarget;
      if (w && w.trim()) {
        vr(w);
        const y = encodeURIComponent(w);
        window.location.href = Ae(c, {
          q: y
        });
      }
    }
  }, [c]), m = (d) => {
    g(d.target.value);
  }, x = W(() => {
    var d;
    p && g(""), (d = a.current) == null || d.focus();
  }, [p, a]);
  return L(() => {
    var d;
    t && ((d = a.current) == null || d.focus(), g(""));
  }, [t, a]), /* @__PURE__ */ n(vo, {
    id: D("searchbar"),
    placeholder: l,
    value: p,
    onChange: m,
    onKeyDown: u,
    autoComplete: "off",
    inputProps: {
      type: "search"
    },
    inputRef: a,
    endAdornment: /* @__PURE__ */ n(yo, {
      position: "end",
      children: /* @__PURE__ */ n(J, {
        onClick: x,
        sx: {
          p: 0,
          color: "grey.400"
        },
        children: p ? /* @__PURE__ */ n(Tr, {}) : e && /* @__PURE__ */ n(On, {})
      })
    }),
    ...i,
    sx: B({
      typography: "body1",
      "& .MuiInputBase-input": {
        height: 22,
        p: 0,
        caretColor: ({
          palette: d
        }) => d.secondary.main,
        WebkitAppearance: "none",
        "::-webkit-search-cancel-button": {
          WebkitAppearance: "none"
        }
      }
    }, o)
  });
}, Rr = ({
  config: e
}) => {
  const {
    navItem: t
  } = e, [o, i] = k(!1), a = Re(null), s = W(() => {
    K(o ? "Close Search" : "Search"), i(!o);
  }, [o]), l = () => {
    K("Close Search"), i(!1);
  }, c = (p) => {
    p.stopPropagation();
  };
  return /* @__PURE__ */ b(h, {
    id: "headerOpenSearch",
    "aria-describedby": D("desktop-search"),
    onClick: s,
    sx: {
      display: "flex",
      alignItems: "center",
      height: 40,
      fontSize: 0,
      color: "common.white",
      cursor: "pointer",
      outline: "none",
      userSelect: "none"
    },
    children: [/* @__PURE__ */ n(h, {
      ref: a,
      sx: {
        position: "absolute",
        top: 0,
        right: 0,
        height: "calc(100% + 8px)"
      }
    }), /* @__PURE__ */ n(Je, {
      text: t,
      bold: o,
      icon: /* @__PURE__ */ n(On, {})
    }), /* @__PURE__ */ n(wt, {
      id: D("desktop-search"),
      open: o,
      onClose: l,
      anchorEl: a.current,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      elevation: 0,
      hideBackdrop: !0,
      sx: {
        "& .MuiPopover-paper": {
          bgcolor: "common.black",
          borderRadius: 1,
          boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1)",
          fontFamily: "inherit"
        }
      },
      children: /* @__PURE__ */ n("div", {
        onClick: c,
        "aria-hidden": "true",
        children: /* @__PURE__ */ n(Mn, {
          focus: o,
          sx: {
            width: 368,
            height: 56,
            p: "0 16px",
            bgcolor: "common.black",
            borderRadius: 1,
            fontFamily: "inherit",
            "& .MuiInputBase-input": {
              color: "common.white"
            }
          }
        })
      })
    })]
  });
}, Ar = () => {
  const e = U(), {
    linksCallbacks: t
  } = te(), o = e.divisions.map((i) => ({
    ...i,
    callback: he(i.name, t)
  }));
  return /* @__PURE__ */ n(h, {
    id: D("main-nav"),
    sx: {
      display: {
        xs: "none",
        lg: "block"
      },
      bgcolor: "common.black"
    },
    children: /* @__PURE__ */ n(ie, {
      children: /* @__PURE__ */ b(h, {
        sx: {
          position: "relative",
          display: "flex",
          justifyContent: "space-between",
          height: 40,
          alignItems: "center",
          WebkitTapHighlightColor: "transparent"
        },
        children: [/* @__PURE__ */ n(Ir, {
          divisions: o,
          ourBrands: e.ourBrands
        }), /* @__PURE__ */ b(h, {
          sx: {
            display: "grid",
            gridAutoFlow: "column",
            gap: 3,
            height: 1
          },
          children: [/* @__PURE__ */ n(Rr, {
            config: e.search
          }), /* @__PURE__ */ n(An, {}), /* @__PURE__ */ n(Pn, {})]
        })]
      })
    })
  });
}, Dn = ({
  logo: e
}) => {
  const t = be(({
    breakpoints: s
  }) => s.up("lg")), {
    centerMobileLogo: o
  } = te(), i = t ? 76 : 57, a = t ? 32 : 24;
  return /* @__PURE__ */ n(h, {
    sx: B({
      height: 1,
      mr: {
        lg: 5
      }
    }, t ? {} : {
      width: 1,
      ml: 2.5
    }, !t && o ? {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      margin: 0
    } : {}),
    children: /* @__PURE__ */ n(G, {
      id: "headerAstroLogo",
      href: e.url,
      onClick: () => K("Astro Logo", e.url),
      sx: {
        display: "flex",
        alignItems: "center",
        height: 1,
        outline: "none",
        userSelect: "none"
      },
      children: /* @__PURE__ */ n("img", {
        src: e.image,
        alt: e.name,
        width: i,
        height: a,
        loading: "eager"
      })
    })
  });
}, Pr = ({
  links: e
}) => {
  const t = xe(e), o = (i, a, s) => (l) => {
    yr(i, a), s && !s() && l.preventDefault();
  };
  return /* @__PURE__ */ n(h, {
    component: "ul",
    sx: {
      position: "absolute",
      top: 68,
      left: -16,
      p: "8px 0",
      bgcolor: "common.white",
      borderRadius: 1,
      border: "1px solid",
      borderColor: "grey.300",
      boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.2)"
    },
    children: t.map(({
      name: i,
      url: a,
      newTabAttributes: s,
      callback: l
    }) => /* @__PURE__ */ n(h, {
      component: "li",
      sx: {
        display: "flex",
        alignItems: "center",
        height: 1,
        fontSize: 0,
        color: "text.primary",
        cursor: "pointer",
        userSelect: "none"
      },
      children: /* @__PURE__ */ n(G, {
        href: a,
        ...s,
        id: `header${i.replace(/\s*\W*/g, "")}`,
        onClick: o(i, a, l),
        "data-title": i,
        variant: "body1",
        sx: {
          display: "inline-block",
          width: 1,
          p: "8px 16px",
          color: "inherit",
          letterSpacing: 0.4,
          ":hover": {
            fontWeight: "bold",
            letterSpacing: "normal",
            textShadow: ({
              palette: c
            }) => `0 0 ${c.text.primary}`,
            WebkitFontSmoothing: "subpixel-antialiased"
          },
          "::before": {
            display: "block",
            content: "attr(data-title)",
            visibility: "hidden",
            overflow: "hidden",
            height: 0,
            fontWeight: "bold",
            letterSpacing: 0.4
          }
        },
        children: i
      })
    }, i))
  });
}, Lr = ({
  navItems: e
}) => {
  const [t, o] = k(!1), [i, a] = k([]), [s, l] = k(), c = xe(e), p = W((u) => {
    o(!0), a(u);
  }, []), g = (u, m, x) => (d) => {
    K(u, m), x && !x() && d.preventDefault();
  };
  return L(() => {
    if (c) {
      const u = c.findIndex((m) => m.links && m.links.some((x) => x.regex && RegExp(x.regex, "i").test(window.location.href)) || m.regex && RegExp(m.regex, "i").test(window.location.href));
      l(u);
    }
  }, [c]), /* @__PURE__ */ n(h, {
    component: "ul",
    sx: {
      display: "grid",
      gridAutoFlow: "column",
      gap: 3,
      height: 1,
      p: 0
    },
    children: c.map(({
      name: u,
      url: m,
      links: x,
      newTabAttributes: d,
      callback: w
    }, y) => /* @__PURE__ */ b(h, {
      component: "li",
      onMouseEnter: () => p(x),
      onMouseLeave: () => o(!1),
      sx: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        height: 80,
        fontSize: 0,
        color: "common.white",
        cursor: "pointer",
        userSelect: "none",
        whiteSpace: "nowrap"
      },
      children: [/* @__PURE__ */ n(G, {
        component: m ? "a" : "button",
        href: m,
        ...d,
        id: `headerNavigation${u.replace(/\s*\W*/g, "")}`,
        onClick: g(u, m, w),
        "data-title": u,
        tabIndex: 0,
        sx: [{
          display: "inline-block",
          fontFamily: "inherit",
          fontSize: "16px",
          lineHeight: "80px",
          color: "primary.contrastText",
          letterSpacing: 0.3,
          outline: "none",
          ":hover, :focus": {
            fontWeight: "bold",
            letterSpacing: "normal",
            textShadow: ({
              palette: C
            }) => `0 0 ${C.primary.contrastText}`,
            WebkitFontSmoothing: "subpixel-antialiased"
          },
          "::before": {
            display: "block",
            content: "attr(data-title)",
            visibility: "hidden",
            overflow: "hidden",
            height: 0,
            fontWeight: "bold",
            letterSpacing: 0.3
          }
        }, s === y && {
          fontWeight: "bold",
          letterSpacing: "normal",
          textShadow: ({
            palette: C
          }) => `0 0 ${C.primary.contrastText}`,
          WebkitFontSmoothing: "subpixel-antialiased"
        }],
        children: u
      }), i && x === i && t && /* @__PURE__ */ n(Pr, {
        links: i
      })]
    }, u))
  });
}, Or = () => {
  const e = U(), {
    linksCallbacks: t
  } = te(), o = e.navItems.map(({
    links: i,
    ...a
  }) => ({
    ...a,
    links: i == null ? void 0 : i.map((s) => ({
      ...s,
      callback: he(s.name, t)
    })),
    callback: he(a.name, t)
  }));
  return /* @__PURE__ */ n(ie, {
    children: /* @__PURE__ */ b(h, {
      sx: {
        display: "flex",
        alignItems: "center",
        height: 80,
        WebkitTapHighlightColor: "transparent"
      },
      children: [/* @__PURE__ */ n(Dn, {
        logo: e.logo
      }), /* @__PURE__ */ n(Lr, {
        navItems: o
      })]
    })
  });
}, Mr = ({
  backgroundSx: e
}) => /* @__PURE__ */ b(z, {
  children: [/* @__PURE__ */ n(Ar, {}), /* @__PURE__ */ n(h, {
    id: D("sub-nav"),
    sx: B(e, {
      display: {
        xs: "none",
        lg: "block"
      }
    }),
    children: /* @__PURE__ */ n(Or, {})
  })]
});
var $e = /* @__PURE__ */ ((e) => (e[e.NonLogin = 1] = "NonLogin", e[e.LoggedIn = 2] = "LoggedIn", e[e.All = 3] = "All", e))($e || {});
const Dr = () => {
  const [e, t] = k(!0), [o, i] = k(), [a, s] = k(), [l, c] = k(""), p = be(({
    breakpoints: V
  }) => V.up("lg")), {
    closeIconColor: g,
    image: {
      name: u,
      url: m,
      mobileImg: x,
      desktopImg: d
    },
    cookieDuration: w,
    applicablePortals: y,
    userSegment: C
  } = lr(), {
    authenticated: E
  } = te(), I = (V, le) => {
    le !== "backdropClick" && t(!1);
  }, $ = W(() => {
    re(nn, 1, w, !1, o);
  }, [w, o]), se = W(() => {
    $(), t(!1);
  }, [$]);
  switch (L(() => {
    i(ve(window.location.hostname)), s(y.find((V) => window.location.href.match(new RegExp(V, "i")))), c(Ae(m, {
      location: encodeURIComponent(window.location.href)
    }));
  }, [y, m]), C) {
    case $e.NonLogin:
      if (E)
        return null;
      break;
    case $e.LoggedIn:
      if (!E)
        return null;
      break;
    case $e.All:
      break;
    default:
      return null;
  }
  return F(nn) || !a ? null : /* @__PURE__ */ b(Pe, {
    id: D("entry-modal"),
    fullScreen: !0,
    open: e,
    onClose: I,
    TransitionProps: {
      onExited: $
    },
    sx: {
      "& .MuiDialog-paper": {
        m: "auto",
        bgcolor: "common.white",
        borderRadius: 0.5,
        overscrollBehavior: "contain",
        width: {
          xs: x.width,
          lg: d.width
        },
        maxHeight: {
          xs: x.height,
          lg: d.height
        }
      }
    },
    children: [/* @__PURE__ */ n(h, {
      sx: {
        position: "absolute",
        right: 0,
        zIndex: 1
      },
      children: /* @__PURE__ */ n(J, {
        id: "entry-modal-close",
        onClick: () => t(!1),
        children: /* @__PURE__ */ n(ye, {
          htmlColor: g
        })
      })
    }), /* @__PURE__ */ n(G, {
      href: l,
      onClick: se,
      sx: {
        width: 1,
        zIndex: 0
      },
      children: /* @__PURE__ */ n(h, {
        component: "img",
        src: p ? d.image : x.image,
        alt: u,
        sx: {
          display: "block",
          width: 1
        }
      })
    })]
  });
}, Wr = ({
  divisions: e,
  ourBrands: t
}) => {
  const [o, i] = k(!1), a = xe(e), s = (c, p, g) => (u) => {
    Te(c, p), g && !g() && u.preventDefault();
  }, l = () => {
    i(!0), Te(t.name);
  };
  return /* @__PURE__ */ b(h, {
    sx: {
      position: "fixed",
      bottom: 0,
      width: 1,
      bgcolor: "common.black"
    },
    children: [/* @__PURE__ */ b(h, {
      sx: {
        display: "grid",
        gridAutoFlow: "column",
        alignItems: "center",
        justifyContent: "center",
        typography: "body2",
        color: "common.white",
        WebkitTapHighlightColor: "transparent"
      },
      children: [a.map((c) => /* @__PURE__ */ n(G, {
        href: c.url,
        ...c.newTabAttributes,
        onClick: s(c.name, c.url, c.callback),
        sx: {
          color: "inherit",
          p: "10px 12px"
        },
        children: c.name
      }, c.name)), /* @__PURE__ */ n(h, {
        component: "span",
        onClick: l,
        sx: {
          p: "10px 12px",
          cursor: "pointer"
        },
        children: t.name
      })]
    }), o && /* @__PURE__ */ n(Ln, {
      open: o,
      onClose: () => i(!1)
    })]
  });
}, Br = () => /* @__PURE__ */ b(N, {
  viewBox: "0 0 20 20",
  color: "primary",
  fontSize: "small",
  children: [/* @__PURE__ */ n("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M3 6.833a.831.831 0 00.244.589l6.667 6.666a.833.833 0 001.178 0l6.667-6.666a.83332542.83332542 0 00-1.179-1.178L10.5 12.321 4.422 6.244A.833.833 0 003 6.833"
  })]
}), jr = (e) => {
  const {
    name: t,
    links: o,
    url: i,
    open: a = !1,
    onClose: s,
    index: l,
    callback: c
  } = e, [p, g] = k(a), [{
    newTabAttributes: u
  }] = xe([e]), m = o ? xe(o) : void 0, x = W((y, C, E) => {
    if (C)
      if (Te(y, C), s && s(), E) {
        const I = E.rel.split(" ").join(","), $ = window.open(C, E.target, I);
        $ && ($.opener = null);
      } else
        window.location.href = C;
  }, [s]), d = W((y) => {
    m ? g((C) => !C) : (c === void 0 || c()) && x(y, i, u);
  }, [m, x]), w = (y, C, E, I) => {
    (I === void 0 || I()) && x(y, C, E);
  };
  return /* @__PURE__ */ b(z, {
    children: [l !== 0 && /* @__PURE__ */ n(xt, {}), /* @__PURE__ */ b(h, {
      id: `headerMobile${t.replace(/\s+|\W+/g, "")}`,
      onClick: () => d(t),
      sx: [{
        display: "grid",
        gridTemplateColumns: "1fr auto"
      }, l === 0 && {
        mt: 1
      }],
      children: [/* @__PURE__ */ n(h, {
        sx: {
          typography: "h3",
          color: "text.primary",
          py: 2,
          px: 0
        },
        children: t
      }), m && /* @__PURE__ */ n(J, {
        sx: {
          p: 0,
          transform: p ? "rotate(180deg)" : "none",
          transition: ({
            transitions: y
          }) => y.create("transform")
        },
        children: /* @__PURE__ */ n(Br, {})
      })]
    }), m && /* @__PURE__ */ n(yt, {
      in: p,
      children: /* @__PURE__ */ n(h, {
        sx: {
          display: "grid",
          gap: 3,
          mt: 1,
          mb: 3
        },
        children: m.map((y) => /* @__PURE__ */ n(R, {
          onClick: () => w(y.name, y.url, y.newTabAttributes, y.callback),
          children: y.name
        }, y.name))
      })
    })]
  });
}, zr = ({
  title: e,
  onClose: t
}) => /* @__PURE__ */ b(h, {
  sx: {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1,
    display: "grid",
    width: 1,
    height: 82,
    p: 2,
    pb: 0,
    gap: 2,
    color: "primary.contrastText",
    backgroundImage: ({
      palette: o
    }) => `linear-gradient(to bottom right, ${o.primary.light}, ${o.primary.dark})`
  },
  children: [/* @__PURE__ */ n(J, {
    id: "headerDrawer",
    onClick: t,
    sx: {
      gridArea: "1 / 1 / 2 / 2",
      placeSelf: "center start",
      padding: 0
    },
    children: /* @__PURE__ */ n(ye, {})
  }), /* @__PURE__ */ n(R, {
    variant: "h3",
    sx: {
      gridArea: "1 / 1 / 2 / 2",
      placeSelf: "start center"
    },
    children: e
  }), /* @__PURE__ */ n(Mn, {
    mobile: !0,
    sx: {
      height: 56,
      padding: "0 16px",
      bgcolor: "background.default",
      border: "solid 1px",
      borderColor: "grey.300",
      borderRadius: 1,
      boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1)",
      "&.Mui-focused": {
        border: "solid 1px",
        borderColor: "secondary.main"
      }
    }
  })]
}), Wn = gt.forwardRef((e, t) => /* @__PURE__ */ n(bt, {
  direction: "right",
  ref: t,
  ...e
}));
Wn.displayName = "DrawerTransition";
const Hr = ({
  open: e,
  onClose: t
}) => {
  const [o, i] = k(!1), {
    navItems: a,
    divisions: s,
    ourBrands: l,
    mobileDrawer: c
  } = U(), {
    linksCallbacks: p
  } = te(), g = s.slice(1).map((w) => ({
    ...w,
    callback: he(w.name, p)
  })), u = a.map(({
    links: w,
    ...y
  }) => ({
    ...y,
    links: w == null ? void 0 : w.map((C) => ({
      ...C,
      callback: he(C.name, p)
    })),
    callback: he(y.name, p)
  })), m = (w, y) => {
    y !== "backdropClick" && i(!1);
  }, x = () => i(!1), d = W(t, [t]);
  return L(() => {
    e && i(!0);
  }, [e]), /* @__PURE__ */ b(Pe, {
    id: D("drawer"),
    open: o,
    onClose: m,
    fullScreen: !0,
    TransitionComponent: Wn,
    TransitionProps: {
      onExited: d
    },
    sx: {
      "& .MuiDialog-container": {
        height: "calc(100% + 100px)"
      },
      "& .MuiDialog-paper": {
        height: "calc(100% - 100px)",
        alignSelf: "flex-start",
        bgcolor: "common.white",
        overscrollBehavior: "contain"
      },
      zIndex: 9999999
    },
    children: [/* @__PURE__ */ n(zr, {
      title: c.title,
      onClose: x
    }), /* @__PURE__ */ n(h, {
      sx: {
        mt: "82px",
        px: 2,
        pt: 4,
        pb: 6,
        WebkitTextSizeAdjust: "100%",
        WebkitTapHighlightColor: "transparent"
      },
      children: u.length > 0 && u.map((w, y) => /* @__PURE__ */ n(jr, {
        index: y,
        onClose: x,
        ...w
      }, w.name))
    }), /* @__PURE__ */ n(Wr, {
      divisions: g,
      ourBrands: l
    })]
  });
}, Ur = () => /* @__PURE__ */ b(N, {
  viewBox: "0 0 20 20",
  fontSize: "small",
  htmlColor: "#fff",
  children: [/* @__PURE__ */ n("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /* @__PURE__ */ n("rect", {
    width: "16",
    height: "2",
    rx: "1",
    transform: "translate(2 4)"
  }), /* @__PURE__ */ n("rect", {
    width: "12",
    height: "2",
    rx: "1",
    transform: "translate(2 9)"
  }), /* @__PURE__ */ n("rect", {
    width: "16",
    height: "2",
    rx: "1",
    transform: "translate(2 14)"
  })]
}), un = ({
  children: e,
  sx: t,
  ...o
}) => /* @__PURE__ */ n(h, {
  ...o,
  sx: B({
    display: "grid",
    gridAutoFlow: "column",
    alignItems: "center"
  }, t),
  children: e
}), $r = ({
  backgroundSx: e
}) => {
  const t = U(), [o, i] = k(!1), a = () => {
    i(!0), Te("Open Menu");
  }, s = () => {
    i(!1), Te("Close Menu");
  };
  return /* @__PURE__ */ n(h, {
    id: D("mobile-nav"),
    sx: B(e, {
      display: {
        xs: "block",
        lg: "none"
      }
    }),
    children: /* @__PURE__ */ b(ie, {
      children: [/* @__PURE__ */ b(h, {
        sx: {
          position: "relative",
          display: "flex",
          justifyContent: "space-between",
          height: 56,
          WebkitTapHighlightColor: "transparent"
        },
        children: [/* @__PURE__ */ n(un, {
          sx: {
            columnGap: 2.5,
            zIndex: 1
          },
          children: /* @__PURE__ */ n(h, {
            id: "headerDrawer",
            onClick: a,
            sx: {
              display: "flex",
              cursor: "pointer"
            },
            children: /* @__PURE__ */ n(Ur, {})
          })
        }), /* @__PURE__ */ n(Dn, {
          logo: t.logo
        }), /* @__PURE__ */ b(un, {
          sx: {
            columnGap: 3
          },
          children: [/* @__PURE__ */ n(An, {}), /* @__PURE__ */ n(Pn, {})]
        })]
      }), o && /* @__PURE__ */ n(Hr, {
        open: o,
        onClose: s
      })]
    })
  });
}, Fr = ({
  background: e = "gradient",
  ...t
}) => {
  const o = ({
    palette: s
  }) => e === "transparent" ? {
    bgcolor: "transparent"
  } : {
    backgroundImage: `linear-gradient(to bottom right, ${s.primary.light}, ${s.primary.dark})`
  }, {
    ref: i,
    inView: a
  } = Ro({});
  return /* @__PURE__ */ b(mr, {
    ...t,
    children: [/* @__PURE__ */ n(hr, {
      showMinimalBanner: !a
    }), /* @__PURE__ */ n(Dr, {}), /* @__PURE__ */ b(h, {
      ref: i,
      component: "header",
      sx: {
        zIndex: "appBar",
        position: "relative"
      },
      children: [/* @__PURE__ */ n($r, {
        backgroundSx: o
      }), /* @__PURE__ */ n(Mr, {
        backgroundSx: o
      })]
    })]
  });
}, Ui = (e) => /* @__PURE__ */ n(Ve, {
  theme: _n,
  children: /* @__PURE__ */ n(Fr, {
    ...e
  })
});
function Le(e) {
  return `acm-footer${e ? `__${e}` : ""}`;
}
const Nr = () => {
  const {
    copyrightHtml: e
  } = ae();
  return /* @__PURE__ */ n(R, {
    variant: "body2",
    dangerouslySetInnerHTML: {
      __html: e
    },
    sx: {
      mt: {
        xs: 3,
        lg: 0
      },
      textAlign: {
        xs: "left",
        lg: "right"
      }
    }
  });
}, Qe = (e, t) => t && ee({
  event: "navEvent",
  content_type: "ACM Footer",
  content_list_type: "Navigation",
  content_title: e,
  content_id: t
}), Gr = () => {
  const {
    footerLinks: e
  } = ae();
  return /* @__PURE__ */ n("nav", {
    id: Le("bottom-links"),
    children: e.map(({
      name: t,
      url: o
    }, i) => /* @__PURE__ */ n(G, {
      href: o,
      onClick: () => Qe(t, o),
      sx: {
        p: "0 8px",
        color: "text.primary",
        borderLeft: ({
          palette: a
        }) => i !== 0 ? `1px solid ${a.text.primary}` : void 0,
        ":first-of-type": {
          pl: 0
        },
        ":last-of-type": {
          pr: 0
        }
      },
      children: t
    }, o))
  });
}, Vr = () => /* @__PURE__ */ b(h, {
  id: Le("bottom-nav"),
  sx: {
    display: "flex",
    flexDirection: {
      xs: "column",
      lg: "row"
    },
    justifyContent: {
      lg: "space-between"
    },
    typography: "body2"
  },
  children: [/* @__PURE__ */ n(Gr, {}), /* @__PURE__ */ n(Nr, {})]
}), Yr = ({
  open: e,
  onClose: t,
  config: {
    heading: o,
    topText: i,
    bottomText: a,
    qrSource: s
  }
}) => {
  const {
    apps: {
      storeBadges: l
    }
  } = ae();
  return /* @__PURE__ */ n(nr, {
    children: /* @__PURE__ */ b(Xo, {
      id: Le("app-modal"),
      open: e,
      onClose: t,
      children: [/* @__PURE__ */ n(ge, {
        sx: {
          mt: 2,
          mx: 2,
          justifyContent: "end"
        },
        children: /* @__PURE__ */ n(J, {
          onClick: t,
          children: /* @__PURE__ */ n(ye, {
            sx: {
              fontSize: 16
            }
          })
        })
      }), /* @__PURE__ */ b(h, {
        sx: {
          textAlign: "center",
          px: 2
        },
        children: [/* @__PURE__ */ n(R, {
          variant: "h2",
          sx: {
            mt: 2
          },
          children: o
        }), /* @__PURE__ */ n(R, {
          sx: {
            mt: 2
          },
          dangerouslySetInnerHTML: {
            __html: i
          }
        }), /* @__PURE__ */ n(h, {
          component: "img",
          src: s,
          alt: "QR code",
          width: 156,
          height: 156,
          sx: {
            mt: 2
          }
        }), /* @__PURE__ */ n(R, {
          sx: {
            mt: 2
          },
          dangerouslySetInnerHTML: {
            __html: a
          }
        })]
      }), /* @__PURE__ */ n(kt, {
        sx: {
          gridTemplateColumns: "repeat(3, auto)",
          gap: 0.5,
          mt: 2,
          mb: 4,
          justifyContent: "center"
        },
        children: l.map((c) => /* @__PURE__ */ n(h, {
          sx: {
            height: "29px"
          },
          children: /* @__PURE__ */ n(h, {
            component: "img",
            src: c.source,
            alt: c.alt,
            sx: {
              maxHeight: 1,
              minWidth: 1
            }
          })
        }, c.source))
      })]
    })
  });
}, qr = () => {
  const {
    apps: {
      heading: e,
      items: t
    }
  } = ae(), o = yn("lg"), [i, a] = k(0), [s, l] = k(!1), c = (g) => {
    o && (a(g), l(!0));
  }, p = () => l(!1);
  return /* @__PURE__ */ b("div", {
    id: Le("apps"),
    children: [/* @__PURE__ */ n(R, {
      variant: "h5",
      component: "h4",
      sx: {
        mt: 4
      },
      children: e
    }), t.map(({
      imageSource: g,
      imageAlt: u,
      text: m,
      url: x
    }, d) => /* @__PURE__ */ b(ge, {
      sx: {
        mt: 2
      },
      children: [/* @__PURE__ */ n(h, {
        component: o ? "div" : "a",
        href: x,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => c(d),
        children: /* @__PURE__ */ b(ge, {
          sx: {
            alignItems: "center",
            cursor: "pointer"
          },
          children: [/* @__PURE__ */ n(h, {
            component: "img",
            src: g,
            alt: u,
            loading: "lazy",
            sx: {
              height: 24,
              width: 24,
              mr: 1,
              verticalAlign: "sub"
            }
          }), /* @__PURE__ */ n(R, {
            variant: "body2",
            children: m
          })]
        })
      }), /* @__PURE__ */ n(h, {
        sx: {
          flex: 1
        }
      })]
    }, m)), t[i] && /* @__PURE__ */ n(Yr, {
      open: s,
      onClose: p,
      config: t[i].modal
    })]
  });
}, Kr = ({
  expand: e,
  first: t
}) => /* @__PURE__ */ n(h, {
  component: "img",
  src: "https://de-acm-assets.eco.astro.com.my/images/icons/dark/arrow-forward.svg",
  alt: "Expand",
  sx: {
    position: "absolute",
    top: `calc(50% - ${t ? 12 : 8}px)`,
    right: 0,
    height: 16,
    transform: `rotate(${e ? 270 : 90}deg)`,
    transition: ({
      transitions: o
    }) => o.create("transform")
  }
}), Bn = ({
  children: e,
  first: t,
  heading: o,
  wrapperSx: i
}) => {
  const [a, s] = k(!1), l = be(({
    breakpoints: p
  }) => p.up("lg"));
  return /* @__PURE__ */ b(z, {
    children: [/* @__PURE__ */ b(h, {
      onClick: () => s((p) => !p),
      sx: {
        position: "relative",
        py: 0,
        cursor: {
          xs: "pointer",
          lg: "default"
        }
      },
      children: [/* @__PURE__ */ n(R, {
        variant: "h5",
        component: "h4",
        sx: {
          m: 0,
          mb: {
            lg: 2
          },
          p: 0,
          pt: {
            xs: t ? 0 : 1,
            lg: 0
          },
          pb: {
            xs: 1,
            lg: 0
          },
          color: "text.primary"
        },
        children: o
      }), !l && /* @__PURE__ */ n(Kr, {
        expand: a,
        first: t
      })]
    }), /* @__PURE__ */ n(yt, {
      in: l || a,
      sx: i,
      children: e
    })]
  });
}, Jr = () => {
  const {
    complaint: {
      image: e,
      name: t,
      url: o
    }
  } = ae();
  return /* @__PURE__ */ n("div", {
    children: /* @__PURE__ */ n(Bn, {
      heading: t,
      wrapperSx: {
        mt: {
          xs: -1,
          lg: 0
        },
        pb: {
          xs: 1,
          lg: 0
        }
      },
      children: /* @__PURE__ */ n("a", {
        href: o,
        onClick: () => Qe(t, o),
        children: /* @__PURE__ */ n(h, {
          component: "img",
          src: e,
          alt: t,
          width: "160",
          height: "76",
          loading: "lazy",
          sx: {
            maxWidth: 160,
            pt: {
              xs: 1,
              lg: 0
            }
          }
        })
      })
    })
  });
}, Zr = () => {
  const {
    contactUsHtml: e,
    socialIcons: t
  } = ae();
  return /* @__PURE__ */ b(h, {
    sx: {
      display: "flex",
      flexDirection: "column",
      pt: {
        xs: 1,
        lg: 0
      }
    },
    children: [/* @__PURE__ */ n(R, {
      component: "span",
      variant: "body2",
      className: "contact-us",
      dangerouslySetInnerHTML: {
        __html: e
      },
      sx: {
        mb: 2,
        "& strong": {
          fontWeight: 800
        }
      }
    }), /* @__PURE__ */ n(h, {
      sx: {
        display: "grid",
        gap: 3,
        gridAutoFlow: "column",
        justifyContent: "start"
      },
      children: t.map(({
        image: o,
        name: i,
        url: a
      }) => /* @__PURE__ */ n("a", {
        href: a,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => Qe(i, a),
        children: /* @__PURE__ */ n(h, {
          component: "img",
          src: o,
          alt: i,
          loading: "lazy",
          sx: {
            height: 16,
            verticalAlign: "sub"
          }
        })
      }, i))
    })]
  });
}, Xr = ({
  links: e
}) => /* @__PURE__ */ n(h, {
  component: "ul",
  sx: {
    display: "grid",
    gap: {
      xs: "16px",
      lg: "10px"
    },
    m: 0,
    p: {
      xs: 2,
      lg: 0
    },
    listStyle: "none"
  },
  children: e.map(({
    name: t,
    url: o
  }) => /* @__PURE__ */ n(h, {
    component: "li",
    sx: {
      m: 0,
      p: 0,
      color: "text.primary",
      fontSize: {
        xs: 14,
        lg: 14
      },
      lineHeight: {
        xs: 1.43,
        lg: 1
      }
    },
    children: /* @__PURE__ */ n("a", {
      href: o,
      onClick: () => Qe(t, o),
      children: t
    })
  }, t))
}), Qr = () => {
  const {
    columns: e
  } = ae();
  return /* @__PURE__ */ n(z, {
    children: e.map(({
      heading: t,
      links: o
    }, i) => /* @__PURE__ */ n("nav", {
      children: /* @__PURE__ */ n(Bn, {
        heading: t,
        first: i === 0,
        wrapperSx: {
          m: {
            xs: "0 -16px",
            lg: 0
          },
          bgcolor: {
            xs: "background.paper",
            lg: "transparent"
          }
        },
        children: /* @__PURE__ */ n(Xr, {
          links: o
        })
      })
    }, t))
  });
}, ei = () => /* @__PURE__ */ b(h, {
  id: Le("top-nav"),
  sx: {
    display: "grid",
    gridTemplateColumns: {
      lg: "repeat(3, 1fr) 3fr"
    },
    gap: {
      lg: "16px"
    }
  },
  children: [/* @__PURE__ */ n(Qr, {}), /* @__PURE__ */ b(h, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: {
        xs: "column",
        lg: "row"
      }
    },
    children: [/* @__PURE__ */ n(Jr, {}), /* @__PURE__ */ b(h, {
      sx: {
        ml: {
          lg: 2
        }
      },
      children: [/* @__PURE__ */ n(Zr, {}), /* @__PURE__ */ n(qr, {})]
    })]
  })]
}), ti = ({
  children: e
}) => /* @__PURE__ */ n(h, {
  component: "footer",
  sx: {
    position: "sticky",
    top: "100vh",
    "::before, ::after": {
      content: "''"
    }
  },
  children: /* @__PURE__ */ n(h, {
    sx: {
      mt: 10,
      color: "text.primary",
      bgcolor: "background.default"
    },
    children: e
  })
}), ni = () => /* @__PURE__ */ n(ti, {
  children: /* @__PURE__ */ b(ie, {
    sx: {
      py: 4
    },
    children: [/* @__PURE__ */ n(ei, {}), /* @__PURE__ */ n(xt, {
      sx: {
        my: 4
      }
    }), /* @__PURE__ */ n(Vr, {})]
  })
}), oi = _e(En, {
  palette: {
    mode: "dark",
    common: { black: "#000" },
    grey: { 100: "#f5f5f5", 600: "#707070" },
    text: {
      primary: "#fff",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5"
    },
    divider: "#707070",
    background: {
      default: "#333",
      paper: "#000"
    }
  },
  typography: {
    h5: { lineHeight: "24px" },
    body2: { lineHeight: "24px" }
  }
}), ri = vt(oi), $i = () => /* @__PURE__ */ n(Ve, {
  theme: ri,
  children: /* @__PURE__ */ n(ni, {})
}), jn = (e) => e && ee({
  event: "navEvent",
  content_type: "Live Chat",
  content_list_type: "Navigation",
  content_title: "Help Assistant",
  content_id: e
}), ii = () => ee({
  event: "navEvent",
  content_type: "Live Chat",
  content_list_type: "Help Assistant Popup",
  content_title: "open"
}), ai = () => ee({
  event: "navEvent",
  content_type: "Live Chat",
  content_list_type: "Help Assistant Popup",
  content_title: "close"
});
function me(e) {
  return `acm-livechat${e ? `__${e}` : ""}`;
}
const si = ({
  title: e,
  description: t
}) => /* @__PURE__ */ b(R, {
  sx: {
    display: "flex",
    flexDirection: "column",
    color: "grey.900",
    pointerEvents: "all",
    textDecoration: "none",
    ":focus": {
      outline: "none"
    }
  },
  children: [/* @__PURE__ */ n(R, {
    component: "b",
    sx: {
      mb: 0.5,
      fontWeight: "bold"
    },
    children: e
  }), /* @__PURE__ */ n("span", {
    children: t
  })]
}), li = ({
  onClose: e
}) => /* @__PURE__ */ n(J, {
  id: me("close-bubble"),
  edge: "end",
  onClick: e,
  sx: {
    mt: -1.5,
    color: "grey.900"
  },
  children: /* @__PURE__ */ n(ye, {})
}), ci = () => /* @__PURE__ */ n(N, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 13",
  sx: {
    position: "absolute",
    bottom: 0,
    right: -8,
    width: 8,
    height: 13,
    fill: "#e1fec6"
  },
  children: /* @__PURE__ */ n("path", {
    d: "M0 0v13h7.006c.919 0 1.344-1.522.649-2.325z"
  })
}), di = ({
  whatsAppUrl: e,
  show: t
}) => {
  const {
    bubbleTitle: o,
    bubbleDesc: i
  } = Rt(), [a, s] = k(!1), [l, c] = k(!1), p = (g) => {
    g.preventDefault(), g.stopPropagation(), requestAnimationFrame(() => {
      s(!0), c(!1), ai();
    });
  };
  return L(() => {
    t && !a && requestAnimationFrame(() => {
      c(!0), ii();
    });
  }, [t, a]), /* @__PURE__ */ b(G, {
    id: me("bubble"),
    href: e,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: () => jn(e),
    sx: {
      position: "absolute",
      bottom: 0,
      right: "calc(100% + 16px)",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      width: {
        xs: "calc(100vw - 96px)",
        sm: 272
      },
      p: 2,
      bgcolor: "#e1fec6",
      borderRadius: 0.5,
      borderBottomRightRadius: 0,
      outline: "none",
      filter: "drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4))",
      opacity: l ? 1 : 0,
      transform: l ? "scale(1)" : "scale(0)",
      transformOrigin: "bottom right",
      transition: ({
        transitions: g
      }) => g.create(["opacity", "transform"]),
      ":hover": {
        bgcolor: "#e1fec6"
      }
    },
    children: [/* @__PURE__ */ n(si, {
      title: o,
      description: i
    }), /* @__PURE__ */ n(li, {
      onClose: p
    }), /* @__PURE__ */ n(ci, {})]
  });
}, pi = Po({
  from: {
    maxWidth: 150
  },
  to: {
    maxWidth: 48
  }
}), ui = ({
  animation: e,
  needHelp: t,
  shrinked: o,
  whatsAppImage: i,
  whatsAppUrl: a
}) => /* @__PURE__ */ b(G, {
  id: me("button"),
  href: a,
  target: "_blank",
  rel: "noopener noreferrer",
  sx: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    width: "auto",
    maxWidth: o ? 48 : "unset",
    height: 48,
    p: 1.5,
    bgcolor: "grey.900",
    borderRadius: 3
  },
  css: Lo({
    animation: e ? `${pi} .4s ease-in-out` : void 0
  }),
  children: [/* @__PURE__ */ n("img", {
    id: me("icon"),
    src: i,
    alt: "WhatsApp",
    width: 24,
    height: 24,
    loading: "lazy"
  }), /* @__PURE__ */ n(R, {
    id: me("help-text"),
    component: "span",
    variant: "body2",
    sx: {
      minWidth: "max-content",
      ml: 1,
      color: o ? "transparent" : "common.white",
      fontWeight: "bold",
      transition: ({
        transitions: s
      }) => s.create("color")
    },
    children: t
  })]
}), fi = ({
  whatsAppUrl: e
}) => {
  const {
    scrollLengthToAppearBubbleInPixels: t,
    idleTimeToShowBubble: o,
    needHelp: i,
    whatsAppImage: a
  } = Rt(), [s, l] = k({
    state: !1,
    animation: !1
  }), [c, p] = k(!1), g = W(() => {
    window.pageYOffset > t && p(!0);
  }, [t]), {
    reset: u
  } = Ao({
    element: document,
    debounce: 250,
    timeout: o * 1e3,
    onIdle: g
  }), m = W(() => {
    u();
  }, [u]);
  return mo(() => {
    const x = () => {
      window.pageYOffset > 0 && requestAnimationFrame(() => {
        l(({
          state: d
        }) => ({
          state: !0,
          animation: !d
        })), p(!1);
      });
    };
    return window.addEventListener("scroll", x, {
      once: !0
    }), () => {
      window.removeEventListener("scroll", x);
    };
  }, []), /* @__PURE__ */ b(z, {
    children: [/* @__PURE__ */ n(ui, {
      animation: s.animation,
      shrinked: s.state,
      needHelp: i,
      whatsAppImage: a,
      whatsAppUrl: e,
      onClick: () => jn(e),
      onAnimationEnd: m
    }), /* @__PURE__ */ n(di, {
      whatsAppUrl: e,
      show: c && s.state
    })]
  });
}, hi = ({
  bottomOffset: e = 0,
  children: t,
  sx: o,
  ...i
}) => /* @__PURE__ */ n(h, {
  ...i,
  sx: B({
    position: "fixed",
    bottom: 16 + e,
    right: 16,
    zIndex: ({
      zIndex: a
    }) => a.appBar + 50,
    transition: ({
      transitions: a
    }) => a.create("bottom")
  }, o),
  children: t
}), mi = ({
  bottomOffset: e,
  whatsAppUrl: t
}) => /* @__PURE__ */ n(hi, {
  id: me(),
  bottomOffset: e,
  children: /* @__PURE__ */ n(fi, {
    whatsAppUrl: t
  })
}), Fi = ({
  path: e
}) => {
  const t = Rt(), [o, i] = k(""), [a, s] = k(0), l = W(() => {
    var u;
    const {
      urlsToEnableLiveChat: c,
      defaultShortCode: p,
      whatsAppLink: g
    } = t;
    if (c.length) {
      const m = c.find((d) => RegExp(d.url).test(window.location.href)), x = (u = m == null ? void 0 : m.shortCode) != null ? u : p;
      i(m && x ? g + encodeURIComponent(x) : "");
    }
  }, [t]);
  return L(() => {
    const c = new MutationObserver(() => {
      const p = document.querySelector("[data-livechat-sticky]");
      s(p ? p.offsetHeight : 0);
    });
    return c.observe(document.body, {
      subtree: !0,
      childList: !0
    }), () => {
      c.disconnect();
    };
  }, []), L(() => {
    const c = () => {
      l();
    };
    return window.addEventListener("popstate", c), () => {
      window.removeEventListener("popstate", c);
    };
  }, [l]), L(() => {
    l();
  }, [e, l]), o ? /* @__PURE__ */ n(Ve, {
    theme: _n,
    children: /* @__PURE__ */ n(mi, {
      whatsAppUrl: o,
      bottomOffset: a
    })
  }) : null;
};
export {
  fe as ACCESS_TOKEN_COOKIE,
  Li as API_LANGUAGE_MAP,
  nr as AcmThemeProvider,
  zi as AutoLogin,
  tn as BCP_SHOWN_COOKIE,
  Jo as Carousel,
  Zo as CarouselItem,
  ye as CloseIcon,
  gn as DEFAULT_LANGUAGE,
  Pe as Dialog,
  nn as ENTRY_MODAL_COOKIE,
  ge as Flex,
  $i as Footer,
  kt as Grid,
  Ui as Header,
  Wi as Headline,
  xn as LANGUAGE_COOKIE,
  mt as LANGUAGE_EVENT,
  Bo as LOGIN_URL_EVENT,
  Fi as LiveChat,
  Hi as NavProvider,
  Yo as NavigationArrowIcon,
  Fe as REFRESH_TOKEN_COOKIE,
  Wo as SUPPORTED_LANGUAGES,
  Oi as SectionDivider,
  Xo as SmallDialog,
  Di as TallDialog,
  Ue as ULM_EPUID_COOKIE,
  on as ULM_HANDLER_TRIGGERED_COOKIE,
  pe as ULM_PAYLOAD_COOKIE,
  Ie as ULM_PROFILE_EVENT,
  Q as ULM_UUID_COOKIE,
  Mi as WhatsAppIcon,
  vn as changeLanguage,
  lt as deepMerge,
  ue as dispatchUlmProfileEvent,
  Ee as extractConfig,
  Ri as fetcher,
  er as generateGlobalStyles,
  tr as generateTheme,
  ct as getAutoLoginUrl,
  F as getCookie,
  ve as getDomain,
  ee as gtmPush,
  Ho as initUlmUrl,
  Ae as interpolate,
  Ai as isErrorResponse,
  bn as isSupportedLanguage,
  Do as logger,
  Uo as login,
  $o as logout,
  Pi as mapFromLookup,
  B as mergeSx,
  zo as psl,
  Fo as refreshSession,
  ht as removeCookie,
  He as removeCookies,
  re as setCookie,
  ji as themeOptions,
  No as updateAuth,
  ir as useAutoLogin,
  yn as useBreakpoint,
  ln as useConst,
  Bi as usePrefersReducedMotion
};
